<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="425"
    height="400"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 -20 314.7 350"
    id="milestone-letsencrypt"
    role="presentation"
    aria-labelledby="letsencryptssl"
  >
    <title id="letsencryptssl">Netlify offers free SSL through Let's Encrypt</title>
    <defs>
      <clipPath id="clip-path" transform="translate(0 -0.1)">
        <rect class="cls-1" x="80.9" y="23.3" width="33" height="32.95" />
      </clipPath>
    </defs>
    <path class="cls-2" d="M276.1,231.9l-.5-.2L136.9,311.4l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M278.6,233.5l-.5-.3L139.7,312.9l.5.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M281.2,235l-.5-.5L142,314.4l.7.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M283.7,236.3l-.5-.3L144.5,316l.8.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M286.3,237.8l-.5-.2L147.1,317.3l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M288.9,239.3l-.6-.2L149.6,318.8l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M291.4,240.9l-.5-.5L152.2,320.3l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M294,242.4l-.5-.5L155,321.9l.5.2Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M296.3,243.9a1.2,1.2,0,0,1-.5-.5L157.3,323.1l.8.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M297.5,246.2a.8.8,0,0,0-.2-.5L160.1,324.9c.3,0,.5.3.8.3Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M298.1,248.8V248L163.2,325.7l1,.2Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M296.5,252.6c.3-.5.8-.7.8-1.2L167.5,326.2H169Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M237.8,210l-.5-.5L98.5,289.4l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M240.3,211.5l-.5-.5L101.1,290.9l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M242.9,212.8l-.5-.3-138.7,80,.7.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M245.4,214.3l-.7-.2L106.2,293.8l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M248,215.8l-.5-.5-138.7,80,.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M250.5,217.4l-.7-.5L111.3,296.8l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M253.1,218.7l-.5-.3-138.7,80,.7.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M255.6,220.2l-.5-.3L116.4,299.6l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M258.2,221.7l-.5-.2L119,301.2l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M260.8,223.3l-.6-.6-138.7,80,.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M263.3,224.8l-.5-.5L124.3,304.2l.6.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M265.9,226.1l-.5-.3L126.6,305.5l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M268.4,227.6l-.5-.5L129.2,307l.8.6Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M271,229.1l-.5-.5-138.7,80,.7.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M273.5,230.4l-.5-.3-138.7,80,.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M199.4,188l-.7-.5L60.2,267.4l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M202,189.3l-.8-.3L62.8,269l.7.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M204.6,190.8l-.8-.2L65.3,270.3l.5.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M207.1,192.3l-.8-.5-138.4,80,.8.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M209.7,193.6l-.8-.2L70.4,273.3l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M212.2,195.2l-.7-.3L73,274.9l.8.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M214.8,196.7l-.8-.3L75.6,276.1l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M217.3,198.2l-.5-.5-138.7,80,.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M219.9,199.8l-.8-.6-138.4,80,.7.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M222.4,201l-.5-.2L83.2,280.7l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M225,202.6l-.8-.3L85.8,282l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M227.5,204.1l-.7-.5L88.3,283.5l.8.6Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M230.1,205.6l-.8-.5-138.4,80,.7.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M232.7,206.9l-.6-.3-138.7,80,.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M234.4,208.2,96,287.9l.8.5,138.4-80Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M163.7,167.3l-.5-.2L24.5,246.8l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M166.2,168.8l-.7-.5L27,248.3l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M168.8,170.4l-.5-.5L29.6,249.8l.7.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M171.3,171.7l-.7-.3-138.5,80,.8.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M173.9,173.2l-.8-.3L34.7,252.6l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M176.5,174.7l-.8-.5-138.5,80,.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M179,176.2l-.5-.5-138.7,80,.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M181.6,177.5l-.8-.2L42.3,257.2l.8.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M184.1,179.1l-.5-.3L44.9,258.5l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M186.7,180.6l-.5-.5L47.5,260l.7.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M189.2,182.1l-.5-.5L50,261.6l.8.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M191.8,183.4l-.8-.3-138.4,80,.7.3Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M194.3,184.9l-.5-.2L55.1,264.4l.8.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M196.9,186.5l-.5-.5L57.7,265.9l.7.5Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M151.7,162.5h-1.3L20.1,237.6c-.2.2-.2.5-.2,1Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M155.5,163.2l-.8-.2L19.6,240.9v.7Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M158.6,164.5c-.3,0-.5-.3-.8-.3L20.4,243.4c0,.3.2.3.2.5Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M160.4,165.5,21.9,245.2l.5.5,138.5-79.9Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M272.2,142.5l-.6.9,2.6,1.6.5-1Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M273.5,140.4l-.6,1,2.6,1.5.5-.9Z" transform="translate(0 -0.1)" />
    <path class="cls-3" d="M282.5,133.5H282v8.6h.5Z" transform="translate(0 -0.1)" />
    <g id="bottom-handle">
      <path
        class="cls-3"
        d="M311.1,96.2v-.3l-2.4-1.4c-1.1-.8-2.8,0-4.1,2l-32.7,46.4c-1.3,1.9-1.6,4.4-.6,5.3s.1.2.2.2l2.6,1.5h.3l1.7-2.5-.9-.4c.2-.1.3-.4.5-.6L308.2,100a2.2,2.2,0,0,0,.5-1.1l.2.2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M274.1,151l-.5-.2-2.6-1.5-.4-.2c-1.4-1.3-1.1-4.2.5-6.5l32.6-46.4a5.1,5.1,0,0,1,3.4-2.5,2.6,2.6,0,0,1,1.9.4l2.2,1.4a.7.7,0,0,1,.4.7,1.7,1.7,0,0,1-.1.7l-2.6,3.7c0,.1-.2.1-.2.3l-32.4,46.2.7.3-2.2,3.3C274.8,150.8,274.4,151,274.1,151Zm33.7-55.9h-.3a3.8,3.8,0,0,0-2.3,1.8l-32.6,46.5c-1.2,1.8-1.3,3.7-.8,4.4s.1,0,.1.2l2.1,1.2.8-1.2-.9-.5.7-.8.4-.5,32.5-46.4c.1-.3.4-.6.6-1l.4-1,.2.3,1.1-1.6-1.6-1C308.1,95.2,307.9,95.1,307.8,95.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M273.7,149.9c-.9-1-.7-3.5.7-5.4L307,98.1c1.3-1.9,3.3-2.7,4.4-1.8s.6,3.5-.7,5.4l-32.6,46.4C276.8,150.2,274.8,150.8,273.7,149.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M275,151.1a2.8,2.8,0,0,1-1.7-.7c-1.2-1.2-1.1-4.1.6-6.4l32.5-46.4c1.1-1.5,2.3-2.5,3.7-2.5a2,2,0,0,1,1.9.7c1.3,1.2,1.1,4.1-.5,6.4L279,148.6c-1.1,1.6-2.4,2.5-3.8,2.5Zm-.6-1.8a.6.6,0,0,0,.7.2c.8,0,1.8-.9,2.5-1.8l32.5-46.4c1.3-1.8,1.4-3.7.8-4.4a.5.5,0,0,0-.6-.2c-.9,0-1.8.9-2.5,1.8l-32.6,46.4C273.9,146.7,273.7,148.6,274.4,149.3Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M291.9,114.7l-.6.9,2.6,1.6.6-1Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M284.6,138.5l-.6-.4L296,121l.5.3Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M293.6,129.9l-10.9,15.5.9.7,10.9-15.6Z" transform="translate(0 -0.1)" />
    </g>
    <path
      class="cls-2"
      d="M120.6,3.8l-1.2-.7c-.1-.1-.4-.1-.5-.3a4.9,4.9,0,0,0-3.3-.2c-3.9.5-5.7,4.2-5.7,4.2L111.3,8h1.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M272.2,243.5c.6-.8,3.5-5.9,0-10.6h-3.8l-.7,3.6-152-87.8c-3.6-2-9.6-1.7-13.7.6l-96.7,53-2-2.4c-4.7,5-1,9.3-1,9.3a4.4,4.4,0,0,0,1.5,1.2l154.9,89.5c3.5,2.1,9.6,1.8,13.7-.5L269.5,246A8.1,8.1,0,0,0,272.2,243.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M164.7,302a11.5,11.5,0,0,1-6.3-1.5L3.4,211.1a6.5,6.5,0,0,1-1.8-1.5s-4.1-4.7,1-10.3l.5-.5,2.2,2.6,96.1-52.9c4.3-2.5,10.7-2.7,14.4-.5l151.3,87.3.7-3.2,4.8.2.2.2c3.7,5.1.5,10.7.1,11.3l-.7-.3.6.4-.3.3a6.7,6.7,0,0,1-2.7,2.3l-97.1,53.4A15.9,15.9,0,0,1,164.7,302ZM3.1,201c-3.4,4.2-.5,7.6-.4,7.8l1.4,1.1,155,89.5c3.3,1.9,9.2,1.6,13-.6l97.1-53.4a6.7,6.7,0,0,0,2.5-2.2h.1c.4-.8,3-5.4.1-9.5h-2.8l-.9,3.8L115.4,149.1c-3.3-2-9.2-1.7-13,.5L5,203.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M166.5,166.8l105.7,61.1,2.1,4.4a7,7,0,0,0,6.2-4.8v-.2h0a9,9,0,0,0,.4-2.8V104.3a13.4,13.4,0,0,0-1.7-6.5Z"
      transform="translate(0 -0.1)"
    />
    <g>
      <path
        class="cls-4"
        d="M281,104.3c0-4.7-2.9-10.2-6.3-12.1L119.7,2.7l-.6-.3a4.7,4.7,0,0,0-3.3-.3c-3.8.6-5.6,4.3-5.6,4.3l1.4,1.2h1.8V127.4c0,4.6,2.9,10.1,6.3,12l152.5,88.2,2.1,4.4a7,7,0,0,0,6.2-4.8V227h0a8.4,8.4,0,0,0,.4-2.7v-120Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M274.3,232.9h-.4l-2.2-4.6-152.4-88c-3.7-2.2-6.8-7.9-6.8-12.8V8.5h-1.2l-1.9-1.8.3-.4c.1-.1,1.9-4,6-4.7a5.9,5.9,0,0,1,3.7.3h.1c.2.1.5.1.6.3L275,91.7c3.7,2.2,6.7,7.8,6.7,12.7v120a9.9,9.9,0,0,1-.3,2.4h0v.4l-.2.4A7.4,7.4,0,0,1,274.3,232.9ZM114.1,6.9V127.6c0,4.4,2.7,9.6,6,11.6l152.8,88.1,1.9,4.3a6.4,6.4,0,0,0,5-4.1v-.6a7.5,7.5,0,0,0,.4-2.6v-120c0-4.4-2.7-9.6-6-11.5L119.2,3.4l-.4-.3a3.9,3.9,0,0,0-2.6-.3H116a7.2,7.2,0,0,0-4.8,3.5l.7.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M270.9,231.6,116,142.2c-3.6-2.1-6.3-7.4-6.3-12.1V10c0-4.7,2.8-6.9,6.3-4.8L270.9,94.5c3.5,2.1,6.3,7.5,6.3,12.1v120C277.2,231.4,274.3,233.6,270.9,231.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M273.3,233.1a6,6,0,0,1-2.9-.8L115.6,142.9c-3.7-2.2-6.8-7.9-6.8-12.8V10c0-2.8,1-4.8,2.5-5.8a4.6,4.6,0,0,1,4.8.3L271,93.9c3.7,2.2,6.7,7.8,6.7,12.7v120c0,2.8-.9,4.8-2.5,5.8A3.2,3.2,0,0,1,273.3,233.1Zm-2.2-2.1a3.6,3.6,0,0,0,3.5.3c1.2-.7,1.7-2.3,1.7-4.5v-120c0-4.4-2.7-9.6-6-11.6L115.6,5.9c-1.3-.7-2.5-.9-3.5-.3s-1.8,2.3-1.8,4.5v120c0,4.4,2.8,9.6,6.1,11.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M269.8,218.5,117.1,130.4a4.9,4.9,0,0,1-2.1-4V13.3c0-1.5,1-2.4,2.1-1.7L269.8,99.8a4.6,4.6,0,0,1,2,3.9V217C271.8,218.5,270.9,219.2,269.8,218.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M270.6,219.5a2,2,0,0,1-1.3-.4l-152.6-88a6.2,6.2,0,0,1-2.5-4.7V13.3a2.6,2.6,0,0,1,1.1-2.4,2,2,0,0,1,2,.2L270,99.2a5.9,5.9,0,0,1,2.5,4.7V217a2.9,2.9,0,0,1-1.1,2.4ZM270,218c.2.1.4.3.7.1s.4-.4.4-1.1V103.9a4.4,4.4,0,0,0-1.8-3.5L116.7,12.3c-.2-.1-.4-.3-.7-.1s-.4.4-.4,1.1V126.4a4.2,4.2,0,0,0,1.7,3.4Z"
        transform="translate(0 -0.1)"
      />
    </g>
    <path
      class="cls-2"
      d="M119.3,128.9a4.9,4.9,0,0,1-2.1-4V11.6c-1.3-.7-2.1,0-2.1,1.7V126.4a4.9,4.9,0,0,0,2.1,4l152.7,88.1c1.2.7,2,0,2-1.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M201.2,186.8l-15.7-9.1a2.9,2.9,0,0,1-1.3-2.4c0-1,.6-1.4,1.3-1l15.7,9.1a2.9,2.9,0,0,1,1.3,2.4C202.5,186.8,201.9,187.2,201.2,186.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M201.8,187.8a1.1,1.1,0,0,1-.8-.3l-15.8-9.1a3.4,3.4,0,0,1-1.7-3,1.5,1.5,0,0,1,.9-1.6,1.4,1.4,0,0,1,1.5,0l15.8,9a3.7,3.7,0,0,1,1.6,3,2.1,2.1,0,0,1-.8,1.7ZM185,175a.6.6,0,0,0-.1.4,2.5,2.5,0,0,0,1,1.8l15.8,9.1h.1a.9.9,0,0,0,.1-.5,2.2,2.2,0,0,0-.9-1.7L185.2,175Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-3" d="M115.6,148.6c-3.3-1.9-8.7-1.7-12.8,0Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M115.6,149.3h-16l2.9-1.3c4.3-2,9.9-2,13.2,0l2.2,1.2Zm-6.9-1.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M272.1,232.9h-3.9l-.6,3.6L164.9,177.2V301.3a16,16,0,0,0,7.4-1.9l97-53.4a5.8,5.8,0,0,0,2.6-2.3C272.6,242.7,275.5,237.6,272.1,232.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M158.7,296,3.8,206.6c-3.6-2.1-3-5.5,1-7.8l97-56.1c4-2.3,10.2-2.6,13.8-.5l154.8,89.4c3.6,2,3.1,5.5-.9,7.8l-97.1,56C168.4,297.7,162.2,298,158.7,296Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M164.7,298a11.5,11.5,0,0,1-6.3-1.5L3.4,207.1a4.6,4.6,0,0,1-2.8-4c0-1.9,1.4-3.7,3.8-5l97-56c4.3-2.5,10.7-2.8,14.4-.6l154.9,89.4a4.6,4.6,0,0,1,2.8,4c0,1.9-1.4,3.7-3.7,5L172.7,296A17.2,17.2,0,0,1,164.7,298Zm-5.6-2.6c3.3,1.9,9.2,1.7,13-.5l97.1-56.1c1.9-1.1,3-2.4,3-3.8a3.5,3.5,0,0,0-2-2.9L115.3,142.7c-3.3-1.9-9.2-1.6-13.1.6l-97,56c-1.9,1.1-3,2.5-3,3.8a3.3,3.3,0,0,0,2,2.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M116.9,150.7l-3.7-2.2c-.7-.4-.7-1.2.3-1.6a3,3,0,0,1,2.9-.2l3.7,2.2c.7.4.7,1.3-.3,1.7A3.7,3.7,0,0,1,116.9,150.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M106.5,157l-4.4-2.5c-.5-.2-.5-.9.1-1.2l.9-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.5.3.5,1-.2,1.3l-.8.4A2.4,2.4,0,0,1,106.5,157Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M107.5,158a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l.8-.5a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.5,1.5,0,0,1,.7,1.2c0,.6-.3,1-1,1.4l-.8.4Zm-.7-1.7a1.6,1.6,0,0,0,1.5-.1l.8-.4v-.2l-4.3-2.4a1.8,1.8,0,0,0-1.6.1l-.8.4v.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M106.6,167.9l-4.4-2.5c-.3-.1-.6-.4-.5-.7s.4-.6.7-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.1,1.2l-4.2,2.3A1.8,1.8,0,0,1,106.6,167.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M107.6,168.8a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,107.6,168.8Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.4h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M116,162.5l-4.4-2.5c-.6-.2-.6-.9.1-1.2l.8-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-.8.4A2.4,2.4,0,0,1,116,162.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M116.9,163.5a3.1,3.1,0,0,1-1.3-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.5.3-.9.9-1.3l.9-.5a3.3,3.3,0,0,1,2.9-.1l4.3,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.2.9-.9,1.3l-.9.5A2.8,2.8,0,0,1,116.9,163.5Zm-4.9-4.1,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l.8-.4.2-.2-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-.9.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M116.1,173.5l-4.4-2.5c-.5-.3-.5-.9.2-1.2l4.1-2.3a2.2,2.2,0,0,1,2.2-.2l4.4,2.5c.5.3.5.9-.2,1.2l-4.1,2.4A2.4,2.4,0,0,1,116.1,173.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M117.1,174.3a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1,1.8,1.8,0,0,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,117.1,174.3Zm-5-4,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l4.2-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M125.6,168l-4.4-2.5c-.6-.2-.6-.9.1-1.2l.9-.4a2.8,2.8,0,0,1,2.2-.2l4.3,2.5c.6.3.6,1-.1,1.3l-.8.4A2.4,2.4,0,0,1,125.6,168Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M126.5,169a3.1,3.1,0,0,1-1.3-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.5.3-.9,1-1.4l.8-.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.3,1.3,0,0,1,.6,1.1c0,.5-.2.9-.9,1.3l-.8.5A4.2,4.2,0,0,1,126.5,169Zm-5-4.2,4.4,2.5a1.6,1.6,0,0,0,1.5-.1l.8-.4v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-.8.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M125.6,179l-4.4-2.5c-.6-.3-.6-.9.1-1.2l4.2-2.4a2.2,2.2,0,0,1,2.1-.1l4.4,2.5c.6.3.6.9-.1,1.2l-4.1,2.3A2.2,2.2,0,0,1,125.6,179Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M126.5,179.8a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.6,1.1,1.4,1.4,0,0,1-.9,1.4l-4.1,2.3A2.3,2.3,0,0,1,126.5,179.8Zm-.5-1.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.2,2.3h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.1,173.5l-4.4-2.5c-.6-.3-.6-.9.1-1.2l.8-.4a2.8,2.8,0,0,1,2.2-.2l4.4,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5l-.8.5A2.4,2.4,0,0,1,135.1,173.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136,174.5l-1.4-.3-4.3-2.5a1.2,1.2,0,0,1-.7-1.1,1.4,1.4,0,0,1,.9-1.4l.9-.4a3.1,3.1,0,0,1,2.8-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-.9,1.3l-.9.4A2.7,2.7,0,0,1,136,174.5Zm-.7-1.6a1.6,1.6,0,0,0,1.5-.1l.9-.4h.1l-4.4-2.5a1.6,1.6,0,0,0-1.5.1l-.8.4-.2.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.2,184.5l-4.4-2.5a.7.7,0,0,1-.6-.7.8.8,0,0,1,.7-.5l4.2-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.2,1.2l-4.1,2.3A2.2,2.2,0,0,1,135.2,184.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136.2,185.3a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,136.2,185.3Zm-.7-1.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M144.5,179l-4.4-2.5c-.5-.3-.5-.9.2-1.2l.8-.4a2.8,2.8,0,0,1,2.2-.2l4.4,2.5a.5.5,0,0,1,.5.7.6.6,0,0,1-.6.5l-.9.4A2.2,2.2,0,0,1,144.5,179Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M145.5,179.9l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1,1.8,1.8,0,0,1,1-1.4l.8-.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1c0,.6-.3,1-1,1.4l-.8.4A2,2,0,0,1,145.5,179.9Zm-.6-1.5a1.8,1.8,0,0,0,1.6-.1l.8-.4v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-.8.4v.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M144.7,190l-4.4-2.5a.5.5,0,0,1-.5-.7.6.6,0,0,1,.6-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-4.1,2.3A2.8,2.8,0,0,1,144.7,190Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M145.6,190.8a2.8,2.8,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9.9-1.3l4.2-2.4a3.1,3.1,0,0,1,2.8-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.2,1.7,1.7,0,0,1-.9,1.4l-4.2,2.3Zm-.5-1.5a2,2,0,0,0,1.5-.2l4.1-2.3h.2l-4.4-2.5a2.9,2.9,0,0,0-1.6.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M154.1,184.5l-4.3-2.5a.7.7,0,0,1-.6-.7.8.8,0,0,1,.7-.5l.8-.4a2.2,2.2,0,0,1,2.2-.2l4.4,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5l-.9.4A2,2,0,0,1,154.1,184.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M155.1,185.4l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.6-1.1,1.4,1.4,0,0,1,.9-1.4l.8-.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-.8.4A2.6,2.6,0,0,1,155.1,185.4Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l.9-.4v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-.8.4-.2.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M154.3,195.5l-4.4-2.5a.5.5,0,0,1-.5-.7.6.6,0,0,1,.6-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-4.1,2.3A2.8,2.8,0,0,1,154.3,195.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M155.2,196.3a3.1,3.1,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.3,2.5a1.2,1.2,0,0,1,.7,1.2,1.4,1.4,0,0,1-.9,1.4l-4.1,2.3A4.5,4.5,0,0,1,155.2,196.3Zm-5-4,4.4,2.5a2,2,0,0,0,1.5-.2l4.1-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M163.6,190l-4.4-2.5c-.3-.1-.6-.4-.5-.7s.4-.6.7-.5l.8-.5a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.3.5.9-.2,1.2l-.8.4A2.2,2.2,0,0,1,163.6,190Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M164.6,190.9l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l.8-.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-.8.4A2.6,2.6,0,0,1,164.6,190.9Zm-.6-1.5a1.6,1.6,0,0,0,1.5-.1l.9-.4v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-.8.4h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M163.8,201l-4.4-2.5c-.6-.3-.6-1,.1-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-4.1,2.3A2.8,2.8,0,0,1,163.8,201Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M164.7,201.9a3.2,3.2,0,0,1-1.4-.3l-4.3-2.4a1.5,1.5,0,0,1-.7-1.3c0-.5.2-.9.9-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-1,1.3l-4.1,2.4A2.1,2.1,0,0,1,164.7,201.9Zm-4.9-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.1-2.3h.1l-4.4-2.5a1.6,1.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M173.1,195.5l-4.4-2.5a.5.5,0,0,1-.5-.7.6.6,0,0,1,.6-.5l.9-.5a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.3.5.9-.2,1.2l-.8.4A2.2,2.2,0,0,1,173.1,195.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M174.2,196.4a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l.8-.4a2.8,2.8,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-.8.4A2.6,2.6,0,0,1,174.2,196.4Zm-5.1-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l.8-.4h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-.9.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M173.2,206.4l-4.4-2.4c-.5-.3-.5-1,.2-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.5.3.5,1-.2,1.3l-4.1,2.3A2.4,2.4,0,0,1,173.2,206.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M174.2,207.4a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.7,1.7,0,0,1-.7-1.3c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1c0,.6-.3,1-1,1.4l-4.1,2.4A1.7,1.7,0,0,1,174.2,207.4Zm-5-4.1,4.4,2.5a3,3,0,0,0,1.6-.2l4.1-2.3v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.1,2.3C169.3,203.2,169.3,203.3,169.2,203.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M182.7,201l-4.4-2.5a.7.7,0,0,1-.3-.9l.4-.4.9-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.2,1.2l-.8.4A2.2,2.2,0,0,1,182.7,201Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M183.7,201.9a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.7,1.7,0,0,1-.7-1.3c0-.5.3-.9,1-1.3l.8-.5a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.5,1.5,0,0,1,.7,1.2c0,.6-.3,1-1,1.4l-.8.4A2.6,2.6,0,0,1,183.7,201.9Zm-5-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l.9-.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-.8.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M182.8,211.9l-4.4-2.4c-.5-.3-.5-1,.2-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4a.7.7,0,0,1,.3.9.8.8,0,0,1-.4.4l-4.2,2.3A2.4,2.4,0,0,1,182.8,211.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M183.8,212.9a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.6-1.1,1.4,1.4,0,0,1,.9-1.4l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,183.8,212.9Zm-5.1-4.1,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3.2-.2-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.1,2.3C178.9,208.8,178.9,208.8,178.7,208.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M192.2,206.4l-4.4-2.4c-.6-.3-.6-1,.1-1.3l.8-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-.8.4C193.8,206.7,192.7,206.9,192.2,206.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M193.1,207.4a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1,1.7,1.7,0,0,1,.9-1.4l.9-.4a3,3,0,0,1,2.9-.2l4.3,2.5a1.2,1.2,0,0,1,.7,1.1,1.4,1.4,0,0,1-.9,1.4l-.9.4C194.4,207.3,193.7,207.4,193.1,207.4Zm-4.9-4,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l.8-.5h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-.9.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M192.3,217.4l-4.4-2.4c-.5-.3-.5-1,.2-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.5.3.5,1-.2,1.3l-4.1,2.3A2.4,2.4,0,0,1,192.3,217.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M193.3,218.4a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-1,1.3l-4.1,2.4A2.6,2.6,0,0,1,193.3,218.4Zm-.7-1.5a2,2,0,0,0,1.5-.2l4.1-2.3h.2l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.2,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M201.8,211.9l-4.4-2.4c-.6-.3-.6-1,.1-1.3l.9-.4a2.4,2.4,0,0,1,2.2-.1l4.3,2.5c.6.2.6.9-.1,1.2l-.8.4A2,2,0,0,1,201.8,211.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M202.8,212.9a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.7,1.7,0,0,1-.7-1.3c0-.5.3-.9,1-1.4l.8-.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.3,1.3,0,0,1,.6,1.1c0,.5-.2.9-.9,1.3l-.8.4A2,2,0,0,1,202.8,212.9Zm-5.1-4,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l.8-.5h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-.8.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M201.8,222.9l-4.4-2.5c-.6-.2-.6-.9.1-1.2l4.2-2.3a2.6,2.6,0,0,1,2.1-.2l4.4,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5l-4.1,2.4A2.4,2.4,0,0,1,201.8,222.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M202.9,223.9a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.2,1.8,1.8,0,0,1-1,1.4l-4.1,2.3Zm-.7-1.5a2,2,0,0,0,1.5-.2l4.1-2.3h.2l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.2,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M211.3,217.4l-4.4-2.4c-.6-.3-.6-1,.1-1.3l.8-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-.8.4A2,2,0,0,1,211.3,217.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M212.2,218.4a2.8,2.8,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.2-.9.9-1.3l.9-.4a2.8,2.8,0,0,1,2.8-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1,1.7,1.7,0,0,1-.9,1.4l-.9.4A2.6,2.6,0,0,1,212.2,218.4Zm-.7-1.5a2,2,0,0,0,1.5-.2l.9-.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-.8.4h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M211.4,228.4l-4.4-2.5c-.5-.2-.5-.9.1-1.2l4.2-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5c.3.1.6.4.5.7s-.4.6-.7.5h0l-4.1,2.4A2.4,2.4,0,0,1,211.4,228.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M212.4,229.4a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-1,1.3l-4.1,2.4A4.2,4.2,0,0,1,212.4,229.4Zm-5.1-4.1,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3v-.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3c.1.2.1.2,0,.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M220.7,222.9l-4.4-2.5c-.5-.2-.5-.9.2-1.2l.8-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.4a.7.7,0,0,1,.3.9.8.8,0,0,1-.4.4l-.9.4A2,2,0,0,1,220.7,222.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M221.7,223.9a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l.8-.4a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.4l-.8.4A2.8,2.8,0,0,1,221.7,223.9Zm-.6-1.5a3,3,0,0,0,1.6-.2l.8-.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-.8.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M221.8,234.9a3.1,3.1,0,0,1-1.3-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.5.3-.9.9-1.4l4.2-2.3a3.1,3.1,0,0,1,2.8-.1l4.4,2.4a1.2,1.2,0,0,1,.7,1.1,1.4,1.4,0,0,1-.9,1.4l-4.2,2.4A2.8,2.8,0,0,1,221.8,234.9Zm-.5-1.5a2,2,0,0,0,1.5-.2l4.1-2.3.2-.2-4.4-2.4a1.8,1.8,0,0,0-1.6.1l-4.1,2.3v.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M230.3,228.5l-4.3-2.4c-.6-.3-.6-1,.1-1.3l.8-.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-.9.4A2.4,2.4,0,0,1,230.3,228.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M231.3,229.4a3.5,3.5,0,0,1-1.4-.3l-4.4-2.5a1.3,1.3,0,0,1-.6-1.1c0-.5.2-.9.9-1.3l.8-.5a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.3l-.8.5A2.8,2.8,0,0,1,231.3,229.4Zm-.7-1.5a2,2,0,0,0,1.5-.2l.9-.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-.8.5h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M106.8,178.8l-4.4-2.4c-.6-.3-.6-1,.1-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-4.1,2.3A2.4,2.4,0,0,1,106.8,178.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M107.7,179.8a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1,1.7,1.7,0,0,1,.9-1.4l4.2-2.3a2.8,2.8,0,0,1,2.8-.2l4.4,2.5a1.2,1.2,0,0,1,.7,1.1,1.4,1.4,0,0,1-.9,1.4l-4.2,2.3C109,179.7,108.3,179.8,107.7,179.8Zm-4.9-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.1-2.3h.2l-4.4-2.5a1.6,1.6,0,0,0-1.5.1l-4.2,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M116.3,184.3l-4.4-2.4c-.6-.3-.6-1,.1-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-4.2,2.3A2.2,2.2,0,0,1,116.3,184.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M117.3,185.3a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.6,1.1c0,.5-.2.9-.9,1.4l-4.1,2.3A2.9,2.9,0,0,1,117.3,185.3Zm-.6-1.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M125.9,189.8l-4.4-2.4c-.6-.3-.6-1,.1-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-4.1,2.3A2.4,2.4,0,0,1,125.9,189.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M126.8,190.8a2.8,2.8,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.2-.9.9-1.3l4.2-2.4a3.1,3.1,0,0,1,2.8-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.2,1.7,1.7,0,0,1-.9,1.4l-4.2,2.3Zm-.7-1.5a2,2,0,0,0,1.5-.2l4.2-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.3,195.3l-4.4-2.4c-.5-.3-.5-1,.2-1.3l4.1-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5a.7.7,0,0,1,.3.9.8.8,0,0,1-.4.4l-4.2,2.3A2.2,2.2,0,0,1,135.3,195.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136.4,196.3a3.1,3.1,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9.9-1.3l4.2-2.4a3.1,3.1,0,0,1,2.8-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.2.9-.9,1.3l-4.2,2.4A2.8,2.8,0,0,1,136.4,196.3Zm-.7-1.5a3,3,0,0,0,1.6-.2l4.1-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M144.9,200.8l-4.3-2.5c-.6-.2-.6-.9.1-1.2l4.1-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5a.5.5,0,0,1,.5.7.6.6,0,0,1-.6.5l-4.2,2.4A2.2,2.2,0,0,1,144.9,200.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M145.9,201.8a3.5,3.5,0,0,1-1.4-.3l-4.4-2.5a1.3,1.3,0,0,1-.6-1.1c0-.5.2-.9.9-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.2,1.8,1.8,0,0,1-1,1.4l-4.1,2.3Zm-.7-1.5a2,2,0,0,0,1.5-.2l4.2-2.3h.1l-4.4-2.5a1.6,1.6,0,0,0-1.5.1l-4.1,2.4h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M154.4,206.3l-4.4-2.5c-.5-.2-.5-.9.2-1.2l4.1-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5c.3.1.6.4.5.7s-.4.6-.7.5l-4.1,2.4A2.2,2.2,0,0,1,154.4,206.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M155.4,207.3a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.2c0,.5-.3.9-1,1.4l-4.1,2.3Zm-5-4.2,4.4,2.5a1.6,1.6,0,0,0,1.5-.1l4.2-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M163.9,211.8l-4.4-2.5c-.5-.2-.5-.9.1-1.2l4.2-2.3a2.2,2.2,0,0,1,2.2-.2l4.3,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5h0l-4.1,2.4A2.2,2.2,0,0,1,163.9,211.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M165,212.8a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.5.3-.9,1-1.4l4.1-2.3a3.3,3.3,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.7,2.7,0,0,1,165,212.8Zm-5.1-4.2,4.4,2.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.4h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M173.5,217.3l-4.4-2.5a.5.5,0,0,1-.5-.7.6.6,0,0,1,.6-.5h0l4.2-2.3a2.2,2.2,0,0,1,2.2-.2l4.4,2.5c.5.3.5.9-.2,1.2l-4.1,2.4A2.2,2.2,0,0,1,173.5,217.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M174.5,218.3a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.5,1.5,0,0,1-.7-1.2c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1,1.8,1.8,0,0,1-1,1.4l-4.1,2.3A2,2,0,0,1,174.5,218.3Zm-5-4,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3.2-.2-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.1,2.3C169.5,214.1,169.5,214.1,169.5,214.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M183,222.8l-4.4-2.5c-.6-.3-.6-.9.1-1.2l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.3.6.9-.1,1.2l-4.1,2.3A1.8,1.8,0,0,1,183,222.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M183.9,223.7l-1.3-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1,1.7,1.7,0,0,1,.9-1.4l4.2-2.3a2.8,2.8,0,0,1,2.9-.1l4.3,2.4a1.2,1.2,0,0,1,.7,1.1,1.4,1.4,0,0,1-.9,1.4l-4.1,2.3A2.3,2.3,0,0,1,183.9,223.7Zm-4.9-3.9,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3.2-.2-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.2,2.3c-.1,0-.1,0-.1.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M192.5,228.3l-4.4-2.5a.5.5,0,0,1-.5-.7.6.6,0,0,1,.6-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-4.2,2.3A1.8,1.8,0,0,1,192.5,228.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M193.6,229.2l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.6,1.1,1.4,1.4,0,0,1-.9,1.4l-4.1,2.3A2.8,2.8,0,0,1,193.6,229.2Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.3v-.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3v.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M203,234.7l-1.3-.2-4.4-2.5a1.2,1.2,0,0,1-.7-1.1,1.4,1.4,0,0,1,.9-1.4l4.2-2.3a2.8,2.8,0,0,1,2.8-.2l4.4,2.5a1.5,1.5,0,0,1,.7,1.2,1.7,1.7,0,0,1-.9,1.4l-4.2,2.4Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l4.2-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3h-.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M106.9,189.7l-4.4-2.5c-.5-.3-.5-.9.2-1.2l4.1-2.3a2.2,2.2,0,0,1,2.2-.2l4.4,2.5c.5.3.5.9-.2,1.2l-4.1,2.4A2,2,0,0,1,106.9,189.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M107.9,190.7a3.2,3.2,0,0,1-1.4-.3l-4.4-2.5a1.4,1.4,0,0,1-.7-1.1,1.8,1.8,0,0,1,1-1.4l4.1-2.3a3.3,3.3,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.7,2.7,0,0,1,107.9,190.7Zm-5-4,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.2-2.3v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.1,2.3C102.9,186.5,102.9,186.5,102.9,186.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M116.5,195.2l-4.4-2.5c-.5-.3-.5-.9.2-1.2l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.3.5.9-.2,1.2l-4.1,2.3A1.8,1.8,0,0,1,116.5,195.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M117.5,196.1l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1,1.8,1.8,0,0,1,1-1.4l4.1-2.3a2.8,2.8,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,117.5,196.1Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.3.2-.2-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.2,2.3v.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M126,200.8l-4.4-2.5c-.5-.2-.5-.9.1-1.2l4.2-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5c.3.1.6.4.5.7s-.4.6-.7.5h0l-4.1,2.4A2.4,2.4,0,0,1,126,200.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M127,201.6l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a2.8,2.8,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,127,201.6Zm-5-3.9,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3.2-.2-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3-.2.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.5,206.3l-4.4-2.5c-.6-.2-.6-.9.1-1.2l4.1-2.3a2.8,2.8,0,0,1,2.2-.2l4.4,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5l-4.1,2.4A2.4,2.4,0,0,1,135.5,206.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136.6,207.1l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,136.6,207.1Zm-.7-1.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.4h.2l-4.4-2.5a3,3,0,0,0-1.6.2l-4.1,2.3h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M145.1,211.8l-4.4-2.5c-.6-.2-.6-.9.1-1.2l4.1-2.3a2.2,2.2,0,0,1,2.2-.2l4.4,2.5a.7.7,0,0,1,.6.7.8.8,0,0,1-.7.5h0l-4.1,2.4A2.4,2.4,0,0,1,145.1,211.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M146,212.6a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.3,2.5a1.4,1.4,0,0,1,.7,1.2,1.4,1.4,0,0,1-.9,1.4l-4.1,2.3A4.5,4.5,0,0,1,146,212.6Zm-.6-1.5a1.6,1.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3H141Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M154.6,217.3l-4.4-2.5c-.6-.3-.6-.9.1-1.2l4.1-2.3a2.2,2.2,0,0,1,2.2-.2l4.4,2.5c.6.3.6.9-.1,1.2l-4.1,2.4A2.4,2.4,0,0,1,154.6,217.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M155.5,218.1a3.2,3.2,0,0,1-1.4-.3l-4.3-2.4a1.2,1.2,0,0,1-.7-1.1,1.4,1.4,0,0,1,.9-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.5,1.5,0,0,1,.7,1.2c0,.6-.3,1-1,1.4l-4.1,2.3Zm-4.9-4,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M164,222.8l-4.4-2.5c-.5-.3-.5-.9.2-1.2l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.3.5.9-.2,1.2l-4.1,2.3A2,2,0,0,1,164,222.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M165.1,223.6a2.8,2.8,0,0,1-1.3-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1,1.7,1.7,0,0,1,.9-1.4l4.2-2.3a2.8,2.8,0,0,1,2.8-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-.9,1.4l-4.2,2.3A2.6,2.6,0,0,1,165.1,223.6Zm-5-4,4.3,2.5a2.9,2.9,0,0,0,1.6-.1l4.1-2.4h.1l-4.4-2.5a2,2,0,0,0-1.5.2l-4.1,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M173.6,228.3l-4.4-2.5c-.3-.1-.6-.4-.5-.7s.4-.6.7-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.1,1.2l-4.2,2.3A2.8,2.8,0,0,1,173.6,228.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M174.6,229.2l-1.4-.2-4.4-2.5a1.5,1.5,0,0,1,.3-2.6l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.4l-4.1,2.3A2.7,2.7,0,0,1,174.6,229.2Zm-4.9-4.1,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M184.1,234.7l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,184.1,234.7Zm-5-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.2-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M107.1,200.7l-4.4-2.5a.5.5,0,0,1-.5-.6.6.6,0,0,1,.6-.6l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.6.2.6.9-.1,1.2l-4.2,2.3A1.8,1.8,0,0,1,107.1,200.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M108,201.6l-1.4-.2-4.4-2.5a1.4,1.4,0,0,1-.6-1.1,1.4,1.4,0,0,1,.9-1.4l4.1-2.3a2.8,2.8,0,0,1,2.9-.1l4.4,2.4a1.4,1.4,0,0,1,.7,1.1c0,.6-.3,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,108,201.6Zm-4.9-4.1,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M116.5,206.2l-4.4-2.5c-.3-.1-.6-.4-.5-.7s.4-.6.7-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.2,1.2l-4.1,2.3A2,2,0,0,1,116.5,206.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M117.6,207.1l-1.3-.2-4.4-2.5a1.2,1.2,0,0,1-.7-1.1,1.4,1.4,0,0,1,.9-1.4l4.2-2.3a2.8,2.8,0,0,1,2.8-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1,1.7,1.7,0,0,1-.9,1.4l-4.2,2.3A2.6,2.6,0,0,1,117.6,207.1Zm-5.1-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.2-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M126.1,211.7l-4.4-2.5c-.3-.1-.6-.4-.5-.7s.4-.6.7-.5l4.1-2.4a2.4,2.4,0,0,1,2.2-.1l4.4,2.5c.5.2.5.9-.1,1.2l-4.2,2.3A2.2,2.2,0,0,1,126.1,211.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M127.1,212.6a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.7,1.7,0,0,1-.7-1.3c0-.5.3-.9,1-1.3l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-1,1.3l-4.1,2.4A2.1,2.1,0,0,1,127.1,212.6Zm-5.1-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.1-2.3h.2l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.6,217.2l-4.4-2.5c-.5-.3-.5-1,.2-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.5.3.5,1-.2,1.3l-4.1,2.3A2.2,2.2,0,0,1,135.6,217.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136.6,218.1a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1,1.8,1.8,0,0,1-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,136.6,218.1Zm-5-4.1,4.4,2.5a2,2,0,0,0,1.5-.2l4.2-2.3h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M145.1,222.6l-4.4-2.4c-.6-.3-.6-1,.1-1.3l4.1-2.3a2.4,2.4,0,0,1,2.2-.1l4.4,2.4c.6.3.6,1-.1,1.3l-4.1,2.3A2,2,0,0,1,145.1,222.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M146.2,223.6a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.3a3,3,0,0,1,2.9-.2l4.4,2.5a1.4,1.4,0,0,1,.7,1.1c0,.5-.3.9-1,1.4l-4.1,2.3A2.6,2.6,0,0,1,146.2,223.6Zm-5.1-4,4.4,2.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.2l-4.4-2.5a2,2,0,0,0-1.5.2l-4.2,2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M154.7,228.1l-4.4-2.4a.7.7,0,0,1-.3-.9.8.8,0,0,1,.4-.4l4.2-2.3a2.4,2.4,0,0,1,2.2-.1l4.3,2.4c.6.3.6,1-.1,1.3l-4.1,2.3A2,2,0,0,1,154.7,228.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M155.7,229.1a3.2,3.2,0,0,1-1.4-.3l-4.4-2.4a1.4,1.4,0,0,1-.7-1.1c0-.6.3-1,1-1.4l4.1-2.4a3.3,3.3,0,0,1,2.9-.1l4.4,2.5a1.4,1.4,0,0,1,.6,1.1c0,.5-.2.9-.9,1.4l-4.1,2.3A2.6,2.6,0,0,1,155.7,229.1Zm-.7-1.5a2.6,2.6,0,0,0,1.5-.1l4.1-2.4h.1l-4.4-2.5a2.6,2.6,0,0,0-1.5.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M165.1,234.6a2.8,2.8,0,0,1-1.3-.3l-4.4-2.5a1.2,1.2,0,0,1-.7-1.1c0-.5.3-.9.9-1.3l4.2-2.4a3.1,3.1,0,0,1,2.8-.1l4.4,2.5a1.2,1.2,0,0,1,.7,1.1c0,.5-.3.9-.9,1.3l-4.2,2.4C166.4,234.5,165.7,234.6,165.1,234.6Zm-.5-1.5a2,2,0,0,0,1.5-.2l4.1-2.3h.1l-4.3-2.5a2.9,2.9,0,0,0-1.6.1l-4.1,2.4h-.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M135.9,228,93.5,203.6c-.6-.3-.6-1,.1-1.4l4-2.3a2.4,2.4,0,0,1,2.3-.2l42.4,24.5c.6.2.6.9-.1,1.3l-4.1,2.5A2.2,2.2,0,0,1,135.9,228Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M136.8,229a3.1,3.1,0,0,1-1.3-.3L93,204.2a1.1,1.1,0,0,1-.6-1.2c0-.5.2-.9.9-1.4l4-2.3a3.5,3.5,0,0,1,3-.1l42.5,24.4a1.5,1.5,0,0,1-.3,2.6l-4,2.3A3.4,3.4,0,0,1,136.8,229ZM93.7,202.9l42.5,24.6a3,3,0,0,0,1.6-.2l4-2.3c.1,0,.1-.2.1-.2L99.5,200.3a1.8,1.8,0,0,0-1.6.1l-4,2.3a.2.2,0,0,1-.2.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M146.3,234.5l-1.4-.3-4.3-2.5a1.2,1.2,0,0,1-.7-1.1,1.4,1.4,0,0,1,.9-1.4l4.1-2.3a3.3,3.3,0,0,1,2.9-.1l4.4,2.4a1.7,1.7,0,0,1,.7,1.3c0,.5-.3.9-1,1.3l-4.1,2.4A4,4,0,0,1,146.3,234.5Zm-4.9-4,4.4,2.4a1.6,1.6,0,0,0,1.5-.1l4.1-2.3v-.2l-4.4-2.4a1.6,1.6,0,0,0-1.5.1l-4.1,2.3v.2Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M232.1,214.6l-.6,1.1,22.7,13.1.7-1.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M218.4,206.8l-.7,1.2,9.5,5.4.7-1.1Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M124,152.1l-.6,1.2,10.9,6.3.7-1.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M274.3,91.6l-3.8,2.5.7,1.2,3.8-2.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M124.1,5l-3.8,2.5.8,1.1,3.8-2.5Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M134.4,10.8l-3.8,2.5.8,1.1,3.8-2.5Z" transform="translate(0 -0.1)" />
    <path class="cls-3" d="M280.1,102.1l-3.1,1.8.7,1.2,3.1-1.8Z" transform="translate(0 -0.1)" />
    <path class="cls-3" d="M116.7,126.2l-1.5.9.7,1.2,1.5-.9Z" transform="translate(0 -0.1)" />
    <path class="cls-3" d="M280.2,217.6l-3.1,1.8.7,1.2,3.1-1.8Z" transform="translate(0 -0.1)" />
    <path class="cls-3" d="M280.2,224.5l-3.1,1.7.7,1.2,3.1-1.8Z" transform="translate(0 -0.1)" />
    <g id="top-handle">
      <path class="cls-2" d="M277.7,51.9l-.5,1L281,55l.5-1Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M270.9,65.7l-.5.9,3.8,2.1.6-.9Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M271.6,60.9l-.6.9,3.9,2.1.5-.9Z" transform="translate(0 -0.1)" />
      <g>
        <path
          class="cls-4"
          d="M308.3,91.1c-12.6-6.9-19.1-30.5-20.3-35.4l.3-.4,1.2-2.5c0-.1,0-.3-.1-.3l-3.7-1.9-1-.5a5,5,0,0,0-3.8.2c-4.7,1.8-9.1,8-9.9,13.8-.6,3.7.5,6.3,2.5,7.4l4.1,2,.3-.4c5.4,2.5,17.3,9.9,22.2,28.3a2.5,2.5,0,0,0,1.2,1.9l4.4,2.2,1.3-3.7h-.2a11.7,11.7,0,0,0,3.3-6.3C310.3,93.3,309.6,91.7,308.3,91.1Z"
          transform="translate(0 -0.1)"
        />
        <path
          class="cls-2"
          d="M305.5,106.6h-.3l-4.4-2.2a4.4,4.4,0,0,1-1.5-2.3c-4.8-17.6-16-24.9-21.2-27.5l-.2.5L273,72.6c-2.3-1.3-3.4-4.4-2.8-8.3.8-6.1,5.5-12.6,10.4-14.4a8.2,8.2,0,0,1,4.4-.3l1.2.6,3.7,1.8a.9.9,0,0,1,.5,1.2v.2L289.1,56c1.4,5.3,7.7,28,19.8,34.6,1.6.8,2.5,2.7,2,5.2a10.7,10.7,0,0,1-3,6.3l-1.5,4.3Zm-3.9-3.8,3.4,1.8.7-2.2-.4-.3.7-.7a11.1,11.1,0,0,0,3-5.9c.3-1.8-.1-3.2-1.1-3.6C295,84.8,288.4,60.8,287.2,56v-.3l.4-.7.8-1.8-3.2-1.6a.9.9,0,0,0-.8-.4,4.7,4.7,0,0,0-3.3.2c-4.4,1.7-8.6,7.6-9.5,13.2-.4,3.2.3,5.6,2.1,6.6l3.4,1.8.3-.4.7.3c5.1,2.3,17.6,9.8,22.8,28.8A2.6,2.6,0,0,0,301.6,102.8Z"
          transform="translate(0 -0.1)"
        />
        <path
          class="cls-2"
          d="M312.3,93.2c-14.1-7.7-20.4-36.4-20.4-36.4-.6-3.9-3.3-5.8-7-4.4s-9.1,8-9.9,13.7,1.1,7.6,4,7.9c0,0,18.6,5,25.2,29.5.4,1.9,1.9,2.9,4,2a11.9,11.9,0,0,0,5.8-8.1C314.2,95.4,313.6,93.7,312.3,93.2Z"
          transform="translate(0 -0.1)"
        />
        <path
          class="cls-2"
          d="M306.7,106.8a4.7,4.7,0,0,1-1.7-.4,3.8,3.8,0,0,1-1.7-2.7c-6.5-23.6-24.5-28.8-24.8-28.8a4.9,4.9,0,0,1-3.3-1.9q-1.8-2.6-1.2-6.9c.8-6.2,5.5-12.6,10.4-14.4,2.1-.7,3.9-.7,5.4.3a6.3,6.3,0,0,1,2.7,4.8c0,.3,6.5,28.3,20.1,35.8,1.6.8,2.5,2.8,2,5.2s-3.2,7.6-6.3,8.8Zm-19.6-54a5.2,5.2,0,0,0-2.1.4c-4.4,1.7-8.7,7.6-9.5,13.2-.3,2.3,0,4.4,1,5.6a3.1,3.1,0,0,0,2.3,1.4c.3.1,19.2,5.5,26,30.1a2.4,2.4,0,0,0,.9,1.5,2.1,2.1,0,0,0,1.9,0c2.5-1,5-4.3,5.4-7.4s-.1-3.2-1.1-3.6c-14.3-7.8-20.6-35.7-20.9-36.9a4.5,4.5,0,0,0-2-3.7A3.1,3.1,0,0,0,287.1,52.8Z"
          transform="translate(0 -0.1)"
        />
        <path
          class="cls-2"
          d="M289.1,61.5c-.5,3.8-3.4,7.8-6.4,9s-5.1-1.1-4.6-4.9,3.5-7.9,6.5-9.1S289.7,57.6,289.1,61.5Z"
          transform="translate(0 -0.1)"
        />
        <path
          class="cls-3"
          d="M281.1,71.2a3.1,3.1,0,0,1-2-.7c-1.2-.9-1.7-2.7-1.4-4.9.6-4,3.6-8.3,6.7-9.4s2.8-.4,3.8.5a5.6,5.6,0,0,1,1.3,4.9c-.5,4-3.5,8.2-6.7,9.3A4.7,4.7,0,0,1,281.1,71.2Zm5-14.5-1.4.2c-2.9,1.1-5.7,5-6.2,8.7-.2,1.9.2,3.4,1.1,4.1a3,3,0,0,0,2.9.3c2.9-1.1,5.8-5,6.2-8.7.3-1.9-.1-3.4-1.1-4.1A1.7,1.7,0,0,0,286.1,56.7Z"
          transform="translate(0 -0.1)"
        />
        <path class="cls-3" d="M286.9,56.3l-7.5,13.9.8.4,7.4-13.9Z" transform="translate(0 -0.1)" />
        <path
          class="cls-3"
          d="M300.2,83a97.7,97.7,0,0,1-8.3-18.7h.5a87.6,87.6,0,0,0,8.2,18.5Z"
          transform="translate(0 -0.1)"
        />
      </g>
    </g>
    <g id="camera">
      <path class="cls-2" d="M255.1,80.2l-3.8,2.5.8,1.2,3.7-2.5Z" transform="translate(0 -0.1)" />
      <path
        class="cls-3"
        d="M284.7,34.5c0-2.4-1.5-5.3-3.3-6.3L259.7,15.7a1.7,1.7,0,0,0-1.8-.2l-.5.2L190.1,54.2a.6.6,0,0,0-.1.4l26.2,44.9h.4l66.6-38.1c.3-.2.7-.3.8-.6a3.9,3.9,0,0,0,.7-2.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M216.3,100.4a1.1,1.1,0,0,1-.9-.5L189.2,55a1.1,1.1,0,0,1-.2-.8c.2-.3.3-.6.6-.7L256.7,15l.8-.4a3.6,3.6,0,0,1,2.5.4l21.7,12.5a8.8,8.8,0,0,1,3.7,7V58.4a3.8,3.8,0,0,1-1,2.9,2.5,2.5,0,0,1-1.2.8l-66.4,38.2ZM190.8,54.6l25.7,43.9,66.3-38h.1c.2,0,.3-.1.4-.3a3.6,3.6,0,0,0,.6-1.8V34.5c0-2.2-1.4-4.8-2.9-5.6L259.3,16.4a1.3,1.3,0,0,0-1.2-.3c-.2,0-.2.2-.3.2h-.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M204,78.8l12.1,20.7h.4l66.6-38.1c.2-.2.7-.3.8-.6a3.9,3.9,0,0,0,.7-2.3v-24l-.3-2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M213.6,99.8,191.9,87.3a8.3,8.3,0,0,1-3.3-6.3V57.1c0-2.5,1.5-3.6,3.3-2.5l21.7,12.5a8,8,0,0,1,3.3,6.3V97.3C217,99.8,215.5,100.9,213.6,99.8Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M215,101a2.8,2.8,0,0,1-1.8-.6L191.5,88a8.8,8.8,0,0,1-3.7-7V57.1c0-1.7.5-2.9,1.5-3.5a2.9,2.9,0,0,1,3,.2L214,66.3a8.5,8.5,0,0,1,3.7,7V97.2a3.8,3.8,0,0,1-1.5,3.4A1.7,1.7,0,0,1,215,101Zm-1-1.9a1.2,1.2,0,0,0,1.4.1,2.5,2.5,0,0,0,.7-2V73.4c0-2.2-1.4-4.8-2.9-5.6L191.5,55.3a1.4,1.4,0,0,0-1.4-.2,2.7,2.7,0,0,0-.7,2.1V81.1c0,2.2,1.4,4.8,2.9,5.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M210.6,93.4l-15.7-9a6,6,0,0,1-2.3-4.5V62.7c0-1.8,1.1-2.6,2.3-1.8L210.6,70a6,6,0,0,1,2.3,4.5V91.7C213,93.4,211.9,94.3,210.6,93.4Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M211.5,94.5a2,2,0,0,1-1.3-.4l-15.7-8.9a7.1,7.1,0,0,1-2.7-5.2V62.7a3,3,0,0,1,1.2-2.6,2.1,2.1,0,0,1,2.3.1L211,69.3a6.6,6.6,0,0,1,2.7,5.2V91.7a3,3,0,0,1-1.2,2.6A1.8,1.8,0,0,1,211.5,94.5ZM194,61.3h-.3a2,2,0,0,0-.4,1.3V79.7a5,5,0,0,0,2,3.9l15.7,9a.8.8,0,0,0,.8.2,2,2,0,0,0,.4-1.3v-17a4.4,4.4,0,0,0-2-3.8l-15.7-9.1A.5.5,0,0,0,194,61.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M198.2,82.6a5.6,5.6,0,0,1-2.3-4.5V61.3l-.8-.5c-1.4-.9-2.4,0-2.4,1.8V79.7c0,1.8,1.1,3.9,2.4,4.5l15.6,9.1c1.4.8,2.3,0,2.3-1.8V91Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M211.5,94.5a2,2,0,0,1-1.3-.4l-15.7-8.9a7.1,7.1,0,0,1-2.7-5.2V62.7a3,3,0,0,1,1.2-2.6,2.1,2.1,0,0,1,2.3.1l1.3.7V78.1a4.4,4.4,0,0,0,2,3.8l15.3,8.8v1a2.6,2.6,0,0,1-1.3,2.6A2,2,0,0,1,211.5,94.5ZM194,61.3h-.3a2,2,0,0,0-.4,1.3V79.7a5,5,0,0,0,2,3.9l15.7,9a.8.8,0,0,0,.8.2,2,2,0,0,0,.4-1.3h0l-14.4-8.4a6.3,6.3,0,0,1-2.7-5.2v-16l-.5-.3Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-3" d="M196.1,80l-3.3,1.8.3.5,3.2-1.8Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M195.6,77.8l-3.2,1.8.3.5,3.2-1.9Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M199.4,83l-3.2,1.8.2.5,3.3-1.8Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M195.6,62.5l-3.2,1.9.3.4,3.2-1.8Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M259.3,15,191.4,53.8l.9,1.4,67.8-38.8Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M263.3,17.2,195.6,56.1l.5,1,67.8-38.9Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M279.8,26.7,212.1,65.6l.5,1,67.8-39Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M283.1,39.1,217.7,76.5l.3.5,65.4-37.4Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M283.1,57.2,217.7,94.6l.3.5,65.4-37.4Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M283.1,29.7,215.3,68.6l.6,1,67.7-39Z" transform="translate(0 -0.1)" />
      <path
        class="cls-3"
        d="M209.3,77.2c0,2.8-1.9,3.9-4.2,2.5a9.7,9.7,0,0,1-4.3-7.4c0-2.7,2-3.8,4.3-2.5A9.6,9.6,0,0,1,209.3,77.2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M207,81a5.7,5.7,0,0,1-2.2-.7,9.7,9.7,0,0,1-4.5-7.9,3.5,3.5,0,0,1,1.5-3.3,3.8,3.8,0,0,1,3.6.3,9.8,9.8,0,0,1,4.5,7.8,3.5,3.5,0,0,1-1.5,3.3A2.4,2.4,0,0,1,207,81Zm-3.8-11-.9.2a2.4,2.4,0,0,0-.9,2.2,8.8,8.8,0,0,0,4,6.9,2.1,2.1,0,0,0,2.4.3,2.3,2.3,0,0,0,1-2.2,9.1,9.1,0,0,0-4-6.9A3,3,0,0,0,203.2,70Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M207.8,76.6c0,1.7-1.2,2.4-2.7,1.6a6,6,0,0,1-2.8-4.8c0-1.8,1.3-2.5,2.8-1.6A6.3,6.3,0,0,1,207.8,76.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M206.3,78.8a2.4,2.4,0,0,1-1.4-.5,6.3,6.3,0,0,1-2.8-5c0-1,.2-1.7.9-2.1a2.2,2.2,0,0,1,2.2.1,6.4,6.4,0,0,1,2.9,5.1,2.3,2.3,0,0,1-1,2.1A.8.8,0,0,1,206.3,78.8Zm-2.5-7.2c-.2,0-.4,0-.5.2a1.7,1.7,0,0,0-.7,1.5,5.9,5.9,0,0,0,2.6,4.5,1.5,1.5,0,0,0,1.7.1,1.7,1.7,0,0,0,.7-1.5,6.3,6.3,0,0,0-2.7-4.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M206.2,75.6c.1.4-.2.7-.6.8s-.3,0-.5-.1a2.7,2.7,0,0,1-1.1-1.9c0-.7.5-1,1.1-.7A2.7,2.7,0,0,1,206.2,75.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M180.8,68l18.8-11.1-16.1-6.6-4.8,1.3v13l.2,2.3,1.6,1.3C180.6,68,180.6,68,180.8,68Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M180.6,68.9c-.1,0-.4,0-.5-.2l-1.9-1.3-.3-2.8V50.9l5.6-1.5,17.7,7.3-20,12C181.1,68.9,180.8,68.9,180.6,68.9Zm-.9-2.5.9.7,17.1-10.2L183.4,51l-3.9,1V64.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M287.9,28a12.4,12.4,0,0,0-5.5-9.7L259.3,5a4.4,4.4,0,0,0-4-.4L179,49h0l2.6,2.1,16.5,7.5,9.7,6.5,2.2,5.7,1.5,14.9a.2.2,0,0,0,.3.1h0l75.8-43.9c.1,0,.1-.2.1-.3s.2-.2.2-.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M211.8,86.7h-.4a1,1,0,0,1-.5-.8l-1.6-14.8-2-5.4-9.5-6.2-16.5-7.4h-.1l-3-2.4v-.8l.4-.2L254.9,4.3a4.2,4.2,0,0,1,4.7.4L282.7,18a13,13,0,0,1,5.9,10.3v13c0,.1,0,.2-.2.4a.9.9,0,0,1-.5.8L212.1,86.4C212.2,86.6,211.9,86.7,211.8,86.7ZM182,50.6,198.5,58c.5.3,8.2,5.5,9.9,6.5h.3l2.3,6.2,1.5,13.9,74.6-43.4V28a11.7,11.7,0,0,0-5.1-9L258.9,5.7a3.6,3.6,0,0,0-3.2-.4L180.4,49.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M287.9,41.5c0-.1.1-.1.1-.2V28a9.6,9.6,0,0,0-1.4-4.9L208.8,67.6l1.2,3.3,1.5,14.9a.2.2,0,0,0,.3.1h0L287.6,42C287.7,41.8,287.9,41.7,287.9,41.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M211,85.9l-1.9-1.1a1.4,1.4,0,0,1-.7-1.1V70.4a5.1,5.1,0,0,0-2.2-3.9L183.1,53.2c-1.2-.7-2.2-.1-2.2,1.3V67.8c0,.4-.3.5-.7.4l-1.9-1.1a1.4,1.4,0,0,1-.7-1.1V52.7c0-3.6,2.5-5,5.5-3.2l23.1,13.3a12.5,12.5,0,0,1,5.5,9.6V85.8C211.7,85.9,211.4,86.2,211,85.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M211.3,86.9a.8.8,0,0,1-.7-.2l-1.9-1.1a2.7,2.7,0,0,1-1.1-1.8V70.5a4.2,4.2,0,0,0-1.8-3.1L182.7,54c-.3-.1-.7-.2-.8-.1a1.2,1.2,0,0,0-.3.8V68a1.6,1.6,0,0,1-.5,1.1,1.1,1.1,0,0,1-1.3,0L177.9,68a2.5,2.5,0,0,1-1.1-1.7V52.9c0-2,.7-3.5,2.1-4.2a4.7,4.7,0,0,1,4.6.4l23.1,13.3a13,13,0,0,1,5.9,10.3V86a1.1,1.1,0,0,1-.6,1.1C211.7,86.7,211.5,86.9,211.3,86.9Zm.1-1.7-.4.7ZM182,52a2.3,2.3,0,0,1,1.4.4l23.1,13.3a5.6,5.6,0,0,1,2.6,4.7V83.7c0,.1.1.4.2.4l1.4.8V72.3a11.5,11.5,0,0,0-5.1-8.9l-23-13.3c-1.3-.7-2.4-.9-3.2-.5a3.3,3.3,0,0,0-1.2,2.9V65.9c0,.1.1.4.2.4l1.4.8V54.5a2.4,2.4,0,0,1,1.1-2.2Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M259.9,5.2,183.7,49.4l.6,1L260.5,6.1Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M284.6,19.8,208.4,64l.6,1,76.2-44.3Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M280.4,17.2,204.2,61.4l.5,1,76.2-44.3Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M181.7,59l-.2-.6,5.2-3,.3.6Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M283.8,44.3l-67,38.3.2.5,67-38.3Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M238.4,56.2,212.5,71l.3.5,25.9-14.8Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M245.6,52.3l-4.2,2.4.3.5,4.1-2.4Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M218,85.1l-.3-.4,5.2-2.9.3.5Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M249.2,50.2l-1.8,1.1.3.4,1.8-1Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M191.9,61.7l-.3-.4,1.8-1.1.3.6Z" transform="translate(0 -0.1)" />
      <path
        class="cls-2"
        d="M235.8,12.7l-.5-.9L254.5.8a4.9,4.9,0,0,1,5.2,0l9.8,5.6-.6,1-9.7-5.7a4.3,4.3,0,0,0-4.1,0Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M190.3,90.4a9.8,9.8,0,0,1-5.1-8.6V75.6h1.1v6.2a8.8,8.8,0,0,0,4.5,7.7Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M192.1,90.1l-.5,1,3.1,1.7.6-1Z" transform="translate(0 -0.1)" />
      <path
        class="cls-3"
        d="M226.6,19.3h0v3.4c0,1,.8,2,2.6,2.4a6.8,6.8,0,0,0,4,0c1.6-.6,2.6-1.4,2.6-2.4V19.4h-9.2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M231.2,26.2l-2.2-.3c-1.9-.6-3.2-1.8-3.2-3.2V19.4a.9.9,0,0,1,.9-.9h9a.9.9,0,0,1,1,.8h0v3.3c0,1.4-1.3,2.6-3.2,3.2Zm-3.9-6.1v2.6c0,.6.9,1.3,1.9,1.7a7.3,7.3,0,0,0,3.6,0c1.3-.4,1.9-1,1.9-1.7V20.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M231.2,21.9c2.5,0,4.5-1.2,4.5-2.6s-2-2.6-4.5-2.6-4.6,1.2-4.6,2.6S228.7,21.9,231.2,21.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M231.2,22.7a6.6,6.6,0,0,1-3.6-.8,3.3,3.3,0,0,1-1.8-2.6,3.3,3.3,0,0,1,1.8-2.6,7.9,7.9,0,0,1,7.3,0,3.3,3.3,0,0,1,1.8,2.6,3.3,3.3,0,0,1-1.8,2.6A8,8,0,0,1,231.2,22.7Zm0-5.2a5.5,5.5,0,0,0-2.8.7,1.7,1.7,0,0,0-.9,1.1c0,.4.2.8.9,1.1a7.1,7.1,0,0,0,5.7,0,1.7,1.7,0,0,0,.9-1.1c0-.4-.3-.8-.9-1.1A5.9,5.9,0,0,0,231.2,17.5Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M233.5,21.5h-1.1v3.4h1.1Z" transform="translate(0 -0.1)" />
      <path
        class="cls-3"
        d="M256.6,49a8.2,8.2,0,0,1-2.4,4.1c.3,0,2.1-.3,2.4,1.4a7.6,7.6,0,0,1,2.3-4.2,1.7,1.7,0,0,1-2.2-1C256.7,49.2,256.6,49.1,256.6,49Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M263.6,45a8.2,8.2,0,0,1-2.4,4.1c.3,0,2.1-.3,2.4,1.4a7.3,7.3,0,0,1,2.3-4.1C265.6,46.5,263.8,46.6,263.6,45Z"
        transform="translate(0 -0.1)"
      />
    </g>
    <path
      class="cls-4"
      d="M25.7,256.8a9,9,0,0,1-.6,4.6c-.8,2,.3,4,3.5,3.1l3.4-2a15.6,15.6,0,0,1-1.1-5.7c0-3.2-2.3-2.6-2.3-2.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M27.1,265.1a3.2,3.2,0,0,1-2.3-.9,3.1,3.1,0,0,1-.2-3.1,9,9,0,0,0,.5-4.3v-.3l3.5-2.9a2.4,2.4,0,0,1,2,.6,3.6,3.6,0,0,1,1.1,2.6,12.5,12.5,0,0,0,1.2,5.4l.3.6-4.1,2.3Zm-.8-8a17.6,17.6,0,0,1-.6,4.6,2.3,2.3,0,0,0,0,2c.6.5,1.4.5,2.6.3l3.1-1.8a25.2,25.2,0,0,1-.8-5.4c0-.6,0-1.5-.6-1.7l-.9-.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M48.1,271.4a9,9,0,0,1-.6,4.3c-.9,1.7.3,4,3.5,3.2l3.1-2.3a15.4,15.4,0,0,1-.9-5.2c0-2.9-2.2-2.3-2.2-2.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M49.8,279.7a2.9,2.9,0,0,1-2.3-.8,3,3,0,0,1-.3-3.5,6.9,6.9,0,0,0,.6-4v-.3l3.2-2.8a2.7,2.7,0,0,1,2,.2,4,4,0,0,1,.8,2.6,18.3,18.3,0,0,0,.9,5.2l.3.3-3.8,2.9A3.4,3.4,0,0,1,49.8,279.7Zm-1.1-8a15.4,15.4,0,0,1-.6,4.3c-.3.9-.3,1.4.3,2a2,2,0,0,0,2.3.6l2.5-2a22.5,22.5,0,0,1-.8-5.2c0-.6,0-1.1-.6-1.4a1.1,1.1,0,0,0-.8-.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M26.3,260.2c-.6-.3-1.2,0-1.7.6a13.3,13.3,0,0,1-5.5,6c-3.4,2-1.4,4,.3,4.3s2.9-.5,4.6-1.1a11,11,0,0,0,2.8-2,10.1,10.1,0,0,1,2.3-1.2,11.4,11.4,0,0,0,4.3-1.7c.3,0,.3-.3.3-.6s-.3-4.8-.8-5.1-1.5-.6-1.7.8-2.6,2-2.9,1.2S27.1,260.5,26.3,260.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M20,272h-.6a3.6,3.6,0,0,1-2.6-2.3c0-.9.3-2,2.3-3.2a15,15,0,0,0,5.2-5.7,2,2,0,0,1,2.3-.9c.8.3,2.3,1.2,2.3,2.1h.5c.3-.3.9-.6.9-1.2a1.7,1.7,0,0,1,.9-1.7c.5-.3,1.1,0,1.7.3s.8.5,1.1,5.7a1.4,1.4,0,0,1-.6,1.2,16.1,16.1,0,0,1-4.3,1.7,3,3,0,0,0-2,.8,12.7,12.7,0,0,1-3.1,2A9.3,9.3,0,0,1,20,272Zm6-11.2a.6.6,0,0,0-.6.6h0c-.8,1.4-2.6,4.9-5.7,6.3-1.2.6-1.7,1.1-1.7,2s.8,1.1,1.7,1.4a10.8,10.8,0,0,0,4-1.1,12.2,12.2,0,0,0,2.9-1.7,4.9,4.9,0,0,1,2.5-1.2,12.3,12.3,0,0,0,4.1-1.7c-.3-3.2-.6-4.6-.9-4.9a.9.9,0,0,0-.6-.3,1.6,1.6,0,0,0-.3.9,2.1,2.1,0,0,1-2.3,2,1.7,1.7,0,0,1-1.7-.9c.3-.5-.6-1.1-1.4-1.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M31.2,260.8a1.4,1.4,0,0,1-.3.9c.3,2,0,3.7-.9,3.7a8.8,8.8,0,0,0-4,1.4c-1.1.8-4.6,3.2-6.3,3.2s-2-.6-2-1.2c-.6,1.5.5,2.3,2,2.6s2.8-.6,4.6-1.1a11,11,0,0,0,2.8-2,10.1,10.1,0,0,1,2.3-1.2,11.4,11.4,0,0,0,4.3-1.7c.3,0,.3-.3.3-.6s-.3-4.9-.8-5.1S31.2,259.1,31.2,260.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M20,272h-.6a4.3,4.3,0,0,1-2.3-1.4,1.9,1.9,0,0,1,0-1.8l.6-1.1.5.8v.3c.3.3.3.6,1.5.6s2.3-.6,6-3.1a9.7,9.7,0,0,1,4-1.5c.3,0,.6-1.4.3-3.1v-.3l.3-.3c0-.3.3-.3.3-.6a1.9,1.9,0,0,1,.8-1.7,1.9,1.9,0,0,1,1.8.3c.2.3.8.6,1.1,5.7a1.4,1.4,0,0,1-.6,1.2,16.1,16.1,0,0,1-4.3,1.7,3,3,0,0,0-2,.8,21.1,21.1,0,0,1-3.1,2.1A9.5,9.5,0,0,1,20,272Zm-1.2-1.4a1.5,1.5,0,0,0,.9.2,10.8,10.8,0,0,0,4-1.1,12.2,12.2,0,0,0,2.9-1.7,4.9,4.9,0,0,1,2.5-1.2,12.3,12.3,0,0,0,4.1-1.7c-.3-3.2-.6-4.6-.9-4.9a.9.9,0,0,0-.6-.3,1.6,1.6,0,0,0-.3.9,1.5,1.5,0,0,1-.2.9c.2,2,0,4-1.2,4.3a8.9,8.9,0,0,0-3.7,1.4c-3.2,2-5.5,3.2-6.6,3.4A1.5,1.5,0,0,0,18.8,270.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M26,264.5a6,6,0,0,0-2.6-1.4v-.9a6.8,6.8,0,0,1,3.2,1.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M24.8,265.7a5.8,5.8,0,0,0-2.5-1.5v-.8a7.3,7.3,0,0,1,3.1,1.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M32.6,265.7l-.9-.3a9,9,0,0,0,0-4l.9-.3C32.6,261.4,33.4,263.7,32.6,265.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M49.5,275.1a2.4,2.4,0,0,1,1.4,2.3.5.5,0,0,0,.5.7.6.6,0,0,0,.7-.4h0a4.3,4.3,0,0,0,1.4-2.3,4.7,4.7,0,0,1-.3-1.7s.9-1.1,1.8.9.3,3.7.3,4.6-1.8,2-3.5,3.1-2.6,3.5-4.6,4.9-6.9,1.1-4.9-2.9,2.6-4.3,2.9-5.7,1.2-4.9,2.6-4.9a2.7,2.7,0,0,1-.6,1.7C47.5,276,48.1,274.6,49.5,275.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M44.9,288.9a4.6,4.6,0,0,1-2.3-.6c-.5-.2-1.7-1.4-.5-3.7a31.7,31.7,0,0,0,1.7-3.4,3.9,3.9,0,0,0,.8-2c1.2-5.2,2.6-5.2,3.2-5.2h.6v1.1a2,2,0,0,1,1.1.3c1.2.3,1.7,1.5,2,2.6l1.5-1.7a4.7,4.7,0,0,1-.3-1.7v-.3l.3-.3a2.4,2.4,0,0,1,1.1-.6c.6,0,1.2.6,1.4,1.5a26.2,26.2,0,0,1,.6,4.3v.5c0,1.2-1.4,2-2.9,3.2l-.8.6a14.3,14.3,0,0,0-2,2.3,27.3,27.3,0,0,1-2.3,2.5C47.2,288.3,46.1,288.9,44.9,288.9Zm2.3-13.2a14.2,14.2,0,0,0-1.1,3.5,10.1,10.1,0,0,1-1.2,2.3,35.9,35.9,0,0,1-1.7,3.4c-.6,1.2-.6,1.7.3,2.3a3.3,3.3,0,0,0,3.7-.3,28.5,28.5,0,0,0,2.3-2.6c.9-.8,1.5-2,2.3-2.6s.6-.2.9-.5,2.3-1.7,2.3-2.3V278a7.8,7.8,0,0,0-.3-3.7c-.3-.6-.6-.6-.6-.6a6.1,6.1,0,0,1,.3,1.4c0,.5,0,1.2-1.7,2.9s-.9.6-1.2.3-.8-.6-.8-.9-.6-1.7-1.2-1.7a1.4,1.4,0,0,0-1.4.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M53.2,273.7a5.1,5.1,0,0,1,.3,1.7c0,.3,0,.3.3.6v.9a4.9,4.9,0,0,1-2,3.7,28.4,28.4,0,0,0-4.9,4.9c-2,3.1-4.6,1.4-4.6,1.4s3.8,1.2,4.9,0,3.2-4,4.6-4.9,3.5-2.3,3.5-3.1.5-2.9-.3-4.6S53.2,273.7,53.2,273.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M45.2,288.6a3.4,3.4,0,0,1-2-.3c-.6-.2-.9-.5-.9-.8v-1.2l.9.6c.3,0,2,1.2,3.7-1.4a40.2,40.2,0,0,1,4.9-5.2,3.7,3.7,0,0,0,1.7-3.4v-1.5a4.7,4.7,0,0,1-.3-1.7v-.3l.3-.3a1.8,1.8,0,0,1,1.2-.5c.6,0,1.1.5,1.4,1.4a19.4,19.4,0,0,1,.6,4.3v.6c0,1.1-1.4,2-2.9,3.1s-.6.3-.8.6a11,11,0,0,0-2,2.3,28.5,28.5,0,0,1-2.3,2.6A6.3,6.3,0,0,1,45.2,288.6Zm9.2-13.2v1.8a6.4,6.4,0,0,1-2,4.3,17.5,17.5,0,0,0-4.6,4.8l-.9,1.2a.3.3,0,0,0,.3-.3c.9-.9,1.5-1.7,2.3-2.6a20.2,20.2,0,0,1,2.3-2.6c.8-.6.6-.3.9-.5s2.3-1.8,2.3-2.3v-.9a7.8,7.8,0,0,0-.3-3.7c-.3-.6-.6-.6-.6-.6A3.2,3.2,0,0,0,54.4,275.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M49.5,280.3a9.6,9.6,0,0,0-4-1.4V278a12.5,12.5,0,0,1,4.6,1.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M48.7,281.7a7.3,7.3,0,0,0-3.8-1.1v-.9a11.1,11.1,0,0,1,4.3,1.5Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M47.2,275.5l-.7,1.6.8.4.7-1.6Z" transform="translate(0 -0.1)" />
    <path
      class="cls-3"
      d="M55,279.7l-.9-.2a6.9,6.9,0,0,0,0-3.5H55A7.7,7.7,0,0,1,55,279.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M46.9,271.4a119.3,119.3,0,0,0,0-18.9c-.3-4-.5-6.9-.5-8.9a11.7,11.7,0,0,1,1.7-6.3l6-8.6a.3.3,0,0,0-.3-.3h0a41.5,41.5,0,0,1-15.5,3.4l-5.7.6s-.3,0,0,.3a12.8,12.8,0,0,1,1.1,7.7c-.5,5.2-1.7,9.2-1.7,15.8a5.2,5.2,0,0,1-6.9-.3s.3-16,0-22.6-.3-8.1,4.9-11S46.4,218,51.8,218s14.9,3.5,14.9,3.5l3.8,2.6s3.4,7.7-6.9,13.7c0,0-6.1,4.6-8.1,6.4v.2a14.2,14.2,0,0,1,1.5,8.1c0,6-1.7,10.3-2.3,16.6l-.3,2A7.7,7.7,0,0,1,46.9,271.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M50.7,272.9a14.3,14.3,0,0,1-4.1-.9l-.2-.3v-.3a119.3,119.3,0,0,0,0-18.9c-.3-3.5-.6-6.6-.6-8.9a11.7,11.7,0,0,1,2-6.6l5.2-7.2a42,42,0,0,1-14.4,2.9l-5.2.6a11.8,11.8,0,0,1,.9,7.4l-.9,5.2c-.5,3.1-.8,6.3-1.1,10.6v.3l-.3.3a5.6,5.6,0,0,1-7.4-.3l-.3-.3v-.3c0-.3.3-16.1,0-22.4s0-8.3,5.1-11.5S45.5,218,51.5,218s14.7,3.2,14.9,3.5l3.8,2.6v.3s3.4,8-6.9,14.6c0,0-5.5,4-7.8,6,.6,1.2,1.5,3.5,1.5,8.1a46.3,46.3,0,0,1-1.2,9.1,64.6,64.6,0,0,0-1.1,7.5l-.3,2.3-.3.3C54.4,271.7,53,272.9,50.7,272.9Zm-3.2-1.8a6.4,6.4,0,0,0,6,0v-1.7a48.8,48.8,0,0,1,1.2-7.5,39.7,39.7,0,0,0,1.1-9.1c0-5.2-1.1-7.5-1.4-7.8a.5.5,0,0,1,.1-.7c0-.1.1-.1.2-.1l8-6.4c8.9-5.4,7.2-12,6.6-12.9l-3.4-2.3c-.9-.3-9.8-3.4-14.7-3.4s-16.3,1.1-21.5,4.3-4.9,4-4.6,10.3,0,20.1,0,22.4c2.6,2,4.9.6,5.8.3A50.7,50.7,0,0,1,32,246.2l.9-5.2c.3-4-.6-6.6-1.2-7.2v-.5c0-.3.3-.3.6-.3l5.7-.6a38,38,0,0,0,15.2-3.5,1.4,1.4,0,0,1,.9.3.6.6,0,0,1,.1.8h-.1l-6,8.6a10.6,10.6,0,0,0-1.7,5.7c0,2.6.2,5.5.5,8.9C48.1,260.2,47.5,269.1,47.5,271.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M31.7,232.7a5.5,5.5,0,0,0-2-1.7l.3-.9a8.6,8.6,0,0,1,2.6,2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M54.4,244.2a2.4,2.4,0,0,0-2.3-.9v-.9a3.8,3.8,0,0,1,3.2,1.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M28.6,255.9a8.7,8.7,0,0,1-3.2-.6l.3-.8s2.9,1.1,5.2,0l.3.8A4,4,0,0,1,28.6,255.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M65.3,235.3C61,233,63,228.4,63,228.4l.9.3c0,.2-1.5,3.7,2,5.7Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M50.7,270.8a11.3,11.3,0,0,1-3.2-.5l.3-.9s2.9,1.2,5.2,0l.2.9C52.7,270.8,51.5,270.8,50.7,270.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M53.5,193.1a1.1,1.1,0,0,1-.3.8A52.3,52.3,0,0,0,51,205.7v1.2l-.3.2a24.7,24.7,0,0,0-4.6,2.3c-2,1.5-7.2,6.1-7.2,6.1l6.3,2.5,14.1-7.1,2.6-9.5-3.8-5.7L55,192.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M45.5,218.9,38,215.7l.6-.5a82.9,82.9,0,0,1,7.2-6.1,13,13,0,0,1,4.6-2.2V206a45.4,45.4,0,0,1,2.3-12.1,1.1,1.1,0,0,0,.3-.8v-.3l2-.9,3.7,3.8,3.7,5.7-2.6,10ZM40,215.2l5.2,2.3,13.5-6.9,2.3-8.9-3.5-5.5-2.8-2.8-.9.3s0,.2-.3.5A58.7,58.7,0,0,0,51.2,206v1.1a1.1,1.1,0,0,1-.5.9,16.5,16.5,0,0,0-4.6,2.3C44.9,210.9,41.5,214,40,215.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M57.3,195.7c-.3.2-2.6-1.5-4.1-3.2,0,0,3.2-9.8,7.8-10s1.7,4.6,1.7,4.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M57.3,196.2c-1.5,0-4.6-3.1-4.6-3.1l-.3-.3v-.3c0-.3,3.4-10,8.3-10.3,1.4,0,2.6.3,2.9,1.1s-.6,4.3-.6,4.6l-5.7,8.6Zm-3.8-3.7a15.9,15.9,0,0,0,3.2,2.6l5.2-8c.2-.6,1.1-2.3.5-3.2a2.5,2.5,0,0,0-2-.6c-2.9,0-5.7,6.3-6.9,9.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M61.3,183s-3.8,1.2-4.6,7.8-4,20.6-7.2,25.2c0,0-1.7,2.6,2.9,4.3s7.7,2,12.3,5.8,6.9,5.1,7.8.6a111,111,0,0,1,6-19.6c2-4,2.9-18.3,2.9-18.3s-2.3-3.8-8.9-6.3C68.2,180.7,61.3,183,61.3,183Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M70.7,230.1c-1.4,0-3.1-1.2-6-3.4a19.8,19.8,0,0,0-9.4-4.6l-2.6-.9c-2-.6-3.2-1.4-3.5-2.9a2.4,2.4,0,0,1,.3-2.3c3.2-4.6,6.3-18.9,6.9-25.2s4.9-8.3,4.9-8.3,7.2-2,11.5-.3c6.6,2.6,9.1,6.3,9.1,6.6v.5c0,.6-.8,14.4-2.8,18.7s-5.2,14.6-5.8,19.2c-.3,1.7-.8,2.9-2,3.2S71,230.1,70.7,230.1Zm-9.1-46.8c-.3,0-3.5,1.5-4.1,7.5s-3.7,20.6-7.1,25.5a2,2,0,0,0,0,1.5c.3.8,1.1,1.4,2.8,2l2.6.8c3.5,1.2,6.3,2,9.8,4.9s4.6,3.4,5.7,3.2.9-.9,1.2-2.3c.8-4.6,4-15.5,6-19.5s2.6-16.1,2.9-17.8a23.7,23.7,0,0,0-8.6-6.1C68.2,181.6,61.9,183.3,61.6,183.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M67.9,182.2c-1.7,1.4-4.6,1.4-6,1.4a1.6,1.6,0,0,1-1.5-.9A18.6,18.6,0,0,1,59,169l9.7-.9,2.3,3.2a3.5,3.5,0,0,1,.6,3.1c-.3,1.2-.3,2.6.9,4.9,3.4,6.3,1.7,7.8-2.9,11.2s-8.6.6-5.2-6.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M66.7,192.2a5,5,0,0,1-2.6-.8c-.8-.6-2.2-2.6-.5-6.9H61.9a2.4,2.4,0,0,1-2.1-1.2A20.2,20.2,0,0,1,58.4,169v-.3L69,167.5l2.3,3.5a5,5,0,0,1,.6,3.4c-.3.9-.3,2.3.9,4.6,3.7,6.9,1.7,8.3-2.9,12.1A7.6,7.6,0,0,1,66.7,192.2Zm-1.7-8c-1.4,2.9-1.4,5.1,0,6.3a3.5,3.5,0,0,0,4.3-.3c4.6-3.4,5.8-4.6,2.6-10.6a8.2,8.2,0,0,1-1.2-5.5,3.1,3.1,0,0,0-.5-2.5l-2-2.9-9.2.8a18.8,18.8,0,0,0,1.4,13c.3.2.6.5.9.5s4,0,5.7-1.4l.6.9C67.3,183.6,66.2,183.9,65,184.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M72.5,164.4c-4-3.5-10.4-.6-11.5-1.2s-.6-2-.6-2.5a5.1,5.1,0,0,0-5.1,4.8,6,6,0,0,0,3.1,6.3c1.4.9,3.2.9,4.9.9a2.5,2.5,0,0,1,2,.6,2.6,2.6,0,0,1,1.4,1.7c0,.6.6.9,1.2.9h1.7l1.7-.6a2.4,2.4,0,0,1,.6,1.1v1.8a7.5,7.5,0,0,0,3.7-6.9C75.1,168.4,74.8,166.4,72.5,164.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M70.5,178.4v-3.1l-1.2.3H67.6a1.8,1.8,0,0,1-1.7-1.2,3.3,3.3,0,0,0-1.2-1.4,4.7,4.7,0,0,0-1.7-.3,11.4,11.4,0,0,1-5.2-.9,6.4,6.4,0,0,1-3.4-6.8c.6-4.6,4.9-5.2,5.7-5.5s.6,0,.6.3.3.3,0,.6-.6,1.4.3,1.7a6.4,6.4,0,0,0,2-.3c2.6-.3,6.6-1.1,9.5,1.4s2.8,3.8,2.8,6.9c.3,5.2-4,7.2-4,7.5Zm.5-4.3.3.3a4.7,4.7,0,0,1,.6,1.5v.5a8.2,8.2,0,0,0,.4-11.6h-.1c-2.6-2.3-6-1.8-8.6-1.2a4.8,4.8,0,0,1-2.9,0,2,2,0,0,1-.9-2.3,4.9,4.9,0,0,0-4,4.3c-.5,4.3,2.6,5.5,2.6,5.5a7.2,7.2,0,0,0,4.6.6,5.9,5.9,0,0,1,2.3.5,4.1,4.1,0,0,1,1.7,2c0,.3.3.3.6.3H69Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M63,171.8l-.6-.8c.3,0,4-2.9,8.1-1.2l-.3.9C66.4,169.3,63,171.8,63,171.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M71.9,174.1l-.9-.5a2.4,2.4,0,0,0-.3-2.3l.6-.6C71.6,171,73,172.7,71.9,174.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M72.2,170.1c-1.5-2.8-5.5-2.6-5.5-2.6v-.8c.3,0,4.6-.3,6.3,3.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M63.6,168.4l-.6-.9a5.9,5.9,0,0,1,2.3-.5v.8A2.2,2.2,0,0,0,63.6,168.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M68.7,178.7c.9-.3,1.8-.5,2.3-1.4s.9-1.4.6-2-1.7-1.2-2.3-.3l-.6.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M69,179.3l-.3-1.1a2,2,0,0,0,1.8-1.2,4.8,4.8,0,0,0,.5-1.7.9.9,0,0,0-.3-.6c-.2,0-.5,0-.8.6l-.6.8-.8-.5.5-.9a2.8,2.8,0,0,1,2.3-1.1,1.3,1.3,0,0,1,1.2,1.4h0a4,4,0,0,1-.6,2.6C71,178.4,70.2,179.3,69,179.3Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M63.9,175.9c0,.5-.3,1.1-.6,1.1a1,1,0,0,1-.9-1.1h0c0-.6.3-1.2.6-1.2A1.3,1.3,0,0,1,63.9,175.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M59.8,176.1c0,.6-.2,1.2-.5,1.2a1.3,1.3,0,0,1-.9-1.2c0-.6.3-1.1.6-1.1S59.6,175.3,59.8,176.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-3"
      d="M57.3,165l-.9-.3a4.4,4.4,0,0,1,3.2-2.6v.8C58.1,162.9,57.3,164.7,57.3,165Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M67.6,191.6l1.4,2.3c0,.3.3.3.6,0a22.1,22.1,0,0,0,5.5-4.6c2-2.8,2.8-6.6-1.2-8.8a10.1,10.1,0,0,1-1.1,5.4A31.2,31.2,0,0,1,67.6,191.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M69.3,194.5c-.3,0-.6-.3-.8-.6l-1.8-2.8.3-.3s3.7-3.2,4.9-5.2a12.6,12.6,0,0,0,1.1-5.1v-1.2l.9.6a4.8,4.8,0,0,1,2.9,3.7,8.6,8.6,0,0,1-1.7,6c-1.8,2.6-4.6,4.1-5.5,4.9Zm-1.1-2.9,1.1,1.8c.9-.6,3.5-2,4.9-4.3a6.4,6.4,0,0,0,1.4-5.2,4.3,4.3,0,0,0-1.4-2.3,9.3,9.3,0,0,1-1.2,4.6A16.6,16.6,0,0,1,68.2,191.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M61.6,190.5a7.2,7.2,0,0,1,2-.9s-.9-3.7,1.1-6.3a4.5,4.5,0,0,1-2.8.3,8.4,8.4,0,0,0-.6,6.6A.3.3,0,0,0,61.6,190.5Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M61.6,191.1h-.3c-.3,0-.3-.3-.6-.6-1.1-3.7.6-6.9.9-6.9l.3-.3h.2a11.5,11.5,0,0,0,2.6-.3l1.7-.5-1.1,1.4c-1.7,2-.9,5.7-.9,5.7v.6h-.5a7.2,7.2,0,0,0-2,.9Zm.8-6.6a9.1,9.1,0,0,0-.5,5.4c.2-.3.8-.3,1.4-.6s-.3-3.1.6-4.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M63,198H61.9c.5-3.8,1.7-7.5,2-7.5l1.1.3A34.9,34.9,0,0,0,63,198Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M66.2,194.5a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M65.9,196.8a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M35.2,219.2l20.9,12,14.4-8.6v-.3L49.5,210Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M56.4,232.1h-.3l-20.9-12c-.3,0-.3-.3-.3-.6s0-.6.3-.6L49.8,210h.9l20.9,12.3c.3,0,.3.3.3.6s0,.6-.3.6l-14.3,8.6ZM36,219.2,56.1,231l13.5-8.1L49.5,211.2Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M57.8,227.8l-.5-.9,6.8-4-4.3-2.6.6-.8,4.9,2.8c.3,0,.3.3.3.6a.9.9,0,0,1-.3.6Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M71,222.9c-6.6,0-13.7-.8-14.6-.8s-6.3,1.1-8.6-.9a2,2,0,0,1-.6-1.4c.3-1.5,2.6-2.6,4-2.9V216c0-.3.6-.5,1.2-.5a17.9,17.9,0,0,1,4.3,2c.9.6,5.4.5,8.9-.6a26.8,26.8,0,0,1,8-.6q0-3,.3-6a61,61,0,0,1,1.4-7.2v-1.7c.6-.6,4.3-5.2,6.9-4s2,2.9,1.7,6.6a44.1,44.1,0,0,1-4.8,17.8,1.3,1.3,0,0,1-1.2.8Zm-14.9-2c.3,0,14.1,1.4,21.5.6a.3.3,0,0,0,.3-.3h0a44.1,44.1,0,0,0,4.6-17.5c.3-4.3-.6-5.2-.8-5.5s-3.8,1.8-5.5,3.5v1.1a32.5,32.5,0,0,0-1.4,6.9c-.3,3.5-.3,6.6-.3,6.6v.9h-.6c-.3,0-4.6-.9-8.3.3s-9.2.5-9.5.5h-.3a9.1,9.1,0,0,0-3.4-1.7h-.3v.3l.3.6-.6.3c-1.4.5-3.4,1.4-3.7,2.3a.5.5,0,0,0,.3.5C50.1,221.8,54.4,221.2,56.1,220.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M75.1,202.8a2.4,2.4,0,0,1-.6-2c0-2.8.6-11.7,4.3-13.5s6,11.2,5.7,14.7-7.7,1.7-8.6,1.4S75.3,203.1,75.1,202.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M80.5,204.8a40.7,40.7,0,0,1-4.9-.5c-.3,0-.5-.3-1.1-.9a3.1,3.1,0,0,1-.9-2.6c0-3.7.9-12,4.6-13.7a3,3,0,0,1,2.6.2c3.1,2.3,4,12.7,4,15a3.1,3.1,0,0,1-1.1,2A8.6,8.6,0,0,1,80.5,204.8Zm-.9-16.9c-.2,0-.2,0-.5.3-2.6,1.1-3.8,7.5-4,12.9a3.4,3.4,0,0,0,.5,1.7c.3.3.3.3.6.3s5.7,1.2,7.2,0a2.2,2.2,0,0,0,.5-.8c.3-2.9-.8-12.1-3.4-13.8C80.2,187.9,79.9,187.9,79.6,187.9Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M75.9,220.6h-.6l.3-1.1h.9c.3,0,.3-.3.3-.6l1.1.3a1.1,1.1,0,0,1-.8,1.1Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M79.9,202a13.3,13.3,0,0,1-2.8-.3l.2-1.2s4.4.9,6.6-.8l.6.8C83.4,201.7,81.7,202,79.9,202Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-3" d="M56.1,231.2l-7.2-16.3L27.4,202l7.8,16.9Z" transform="translate(0 -0.1)" />
    <path
      class="cls-2"
      d="M56.1,232.1l-.6-.3L34.3,219.5v-.3l-7.7-17.5.2-.3a.6.6,0,0,1,.8-.1h.1l21.8,12.9v.3L57,231.2ZM35.5,218.6,55,229.8l-6.3-14.6L28.6,203.4Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-4"
      d="M40.6,217.8c.9,1.1,2,1.7,2.6,1.4s.3-1.7-.6-2.9-2-1.7-2.6-1.4S39.8,216.6,40.6,217.8Z"
      transform="translate(0 -0.1)"
    />
    <path
      class="cls-2"
      d="M42.6,219.8a1.1,1.1,0,0,1-.8-.3A6.5,6.5,0,0,1,40,218c-.8-1.1-1.4-2.8-.5-3.7s2.3.3,3.4,1.4a3.3,3.3,0,0,1,.9,2.1c.3,1.1,0,1.4-.3,1.7S43.2,219.8,42.6,219.8Zm-2.3-4.3c-.3.2,0,1.1.9,2s1.7,1.4,1.7,1.1a3,3,0,0,0-.8-2C41.2,215.7,40.6,215.5,40.3,215.5Z"
      transform="translate(0 -0.1)"
    />
    <path class="cls-2" d="M126.6,25.6l-6.8,4.2,1,1.6,6.8-4.2Z" transform="translate(0 -0.1)" />
    <path class="cls-2" d="M129.4,33.1,122,37.9l1,1.5,7.4-4.7Z" transform="translate(0 -0.1)" />
    <path class="cls-4" d="M129.3,39.8l-5.9,3.8v24l5.9-3.3Z" transform="translate(0 -0.1)" />
    <g id="letsencrypt">
      <path
        class="cls-2"
        d="M158.9,92.8l-2.5-1.5v11.8l6.4,3.8v-2.5l-3.9-2.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M165.8,103.5a.8.8,0,0,1,.2-.5.3.3,0,0,1,.3-.3h.6a.9.9,0,0,1,.6.3,2.4,2.4,0,0,1,1,1,2.3,2.3,0,0,1,.4,1.4Zm1.6-2.6a2.7,2.7,0,0,0-1.5-.5,2.9,2.9,0,0,0-1.3.1,2.4,2.4,0,0,0-.8.9,4.7,4.7,0,0,0-.3,1.7,7.6,7.6,0,0,0,.3,2.1,6.6,6.6,0,0,0,.9,1.9l1.3,1.6a3.3,3.3,0,0,0,1.5,1.1,3.2,3.2,0,0,0,1.9.7,2,2,0,0,0,1.4-.6l-1.6-2.1a.9.9,0,0,1-.7.3l-.9-.3-.7-.5-.5-.6a1.6,1.6,0,0,1-.4-.7c0-.3-.1-.5-.1-.7l5.2,3v-.6a7.6,7.6,0,0,0-.3-2.1l-.7-1.8a6.1,6.1,0,0,0-1.2-1.6,4.7,4.7,0,0,0-1.5-1.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M174.8,103.3l-2.3-1.3v2.1l-1.2-.6v2.1l1.2.6v3.5a4.9,4.9,0,0,0,.1,1.2,5.6,5.6,0,0,0,.4,1.2l.8,1a3,3,0,0,0,1.3.9l.7.4.6.2v-2h-.3l-.4-.2c-.4-.1-.5-.4-.7-.7a3.6,3.6,0,0,1-.2-1v-3.1l1.7,1v-2.1l-1.7-.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M182.6,109.7l-1.1-.5h-1a1.8,1.8,0,0,0-.7.5,1.7,1.7,0,0,0-.3,1,4.3,4.3,0,0,0,.2,1.1,3.1,3.1,0,0,0,.5,1c.1.3.4.5.7.8a4.6,4.6,0,0,1,.7.7,5.2,5.2,0,0,1,1.1,1,1.1,1.1,0,0,1,.3.8c0,.3-.1.4-.2.4l-.6-.2-1-.8a4.4,4.4,0,0,0-.8-1.1l-1.3.8a4.9,4.9,0,0,0,1.4,1.8l1.7,1.3,1.1.5a1.7,1.7,0,0,0,1,.1,1.8,1.8,0,0,0,.7-.5,2,2,0,0,0,.3-1.1,5,5,0,0,0-.2-1.2,2.4,2.4,0,0,0-.6-1.1,3.1,3.1,0,0,0-.7-.9l-.8-.7-1-.9c-.1-.2-.3-.4-.2-.7s.1-.3.2-.3h.7l.8.8a2.7,2.7,0,0,0,.7.8l1.3-.8a6.5,6.5,0,0,0-1.3-1.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M196.8,114.7l-6.9-4v11.7l7.2,4.2v-2.5l-4.8-2.6V119l4.2,2.5v-2.4l-4.2-2.4v-2.2l4.5,2.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M203,121.5l-.7-.2h-.6l-.5.2c-.2.1-.3.1-.4.3v-1.1l-2.3-1.4v8.3l2.4,1.4v-4.5a1.3,1.3,0,0,1,.1-.6c.1-.2.1-.4.2-.5h.9l.6.5.3.5a1.9,1.9,0,0,1,.2.7c0,.3.1.5.1.7v4.6l2.4,1.3v-5.1a5.7,5.7,0,0,0-.1-1.3,6.5,6.5,0,0,0-.4-1.3,5.7,5.7,0,0,0-.8-1.3A5.3,5.3,0,0,0,203,121.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M210.5,125.8a4.4,4.4,0,0,0-1.6-.6,1.7,1.7,0,0,0-1.2.2,2,2,0,0,0-.9.9,9.4,9.4,0,0,0-.4,1.6,6.4,6.4,0,0,0,.3,2,6.6,6.6,0,0,0,.9,1.9l1.2,1.6a10.9,10.9,0,0,0,1.7,1.3l1.5.6a1.4,1.4,0,0,0,1.1-.1l-1.3-2.6c-.2.1-.4.2-.5.1a1.1,1.1,0,0,1-.8-.3l-.7-.5-.5-.8a3.6,3.6,0,0,1-.4-.9,2.8,2.8,0,0,1-.1-.9,1.7,1.7,0,0,1,.1-.7c.1-.2.2-.4.4-.4l.5-.2.7.2a1.6,1.6,0,0,1,.8.6,2.2,2.2,0,0,1,.5.8l1.3-1.1a1.8,1.8,0,0,0-.5-.7l-.6-.7-.7-.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M218.3,130.4a1.1,1.1,0,0,0-1.1-.3.9.9,0,0,0-.8.6v-1.1l-2.4-1.4v8.3l2.4,1.3v-4.7l.3-.5.5-.2.8.3.3.2.3.3v-2.4h-.2C218.6,130.5,218.4,130.4,218.3,130.4Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M227.5,135.9l-2.5-1.4-1.4,4.5h-.1l-1.6-6.3-2.6-1.5,2.9,9.8-.2.6-.5.6c-.1.1-.4,0-.8-.2l-.3-.3c-.2-.1-.3-.1-.4-.3l-.3,2.1a1.8,1.8,0,0,0,.7.5l.7.4,1.1.6h.9a1.3,1.3,0,0,0,.7-.6,3.6,3.6,0,0,0,.4-.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M232.2,144.9a2.7,2.7,0,0,1-.8-.7l-.5-.8a1.6,1.6,0,0,1-.3-.9,2.8,2.8,0,0,1-.1-.9,1.7,1.7,0,0,1,.1-.7c0-.2.1-.3.3-.4l.5-.2.8.3c.2.2.5.3.7.6l.5.8a3.6,3.6,0,0,1,.4.9,2.2,2.2,0,0,1,.1.8,1.7,1.7,0,0,1-.1.7l-.4.6h-1.2Zm.6-6.2a2.3,2.3,0,0,0-1.4-.4c-.3,0-.7.1-.8.3v-1l-2.3-1.3v12.2l2.4,1.4V145l.9,1.3a6.9,6.9,0,0,0,1.3,1.1,2.3,2.3,0,0,0,1.4.4,2,2,0,0,0,1.1-.3,6.1,6.1,0,0,0,.7-1,4,4,0,0,0,.3-1.5,5.7,5.7,0,0,0-.3-1.8,13.4,13.4,0,0,0-.7-1.8,5.7,5.7,0,0,0-1.1-1.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M239.9,140.9l-2.3-1.3v2.1l-1.1-.6v2.1l1.1.6v3.5a4.9,4.9,0,0,0,.1,1.2,6.1,6.1,0,0,0,.5,1.2,4.4,4.4,0,0,0,.8,1.1l1.2.9.7.3.6.2v-2.1h-.7l-.7-.7a3.6,3.6,0,0,1-.2-1v-3.2l1.7,1v-2l-1.7-1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M178.6,104c-.7-.4-1.2-.1-1.2.7a2,2,0,0,0,1.2,1.9h.1a.8.8,0,0,1-.8.6h-.3v1.2h.1a1.6,1.6,0,0,0,1.5.1,2.2,2.2,0,0,0,.8-2A2.9,2.9,0,0,0,178.6,104Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M142,76.3c-2.5-1.4-4.5-.2-4.5,2.6v1.5L140,82V80.4c0-1.2.9-1.7,2-1a4.2,4.2,0,0,1,2,3.4v1.5l2.6,1.5V84.3A10.3,10.3,0,0,0,142,76.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M142,91.3a1.1,1.1,0,0,1-.5-.9V89a2,2,0,0,1-.6-1.5c0-.7.5-1.1,1.1-.6a2.5,2.5,0,0,1,1.2,1.9c0,.6-.3.8-.7.8V91C142.5,91.3,142.3,91.5,142,91.3Zm5.6-5-1-.6L144,84.2,140,82l-2.5-1.6-1.1-.6c-.5-.2-.9-.1-.9.6v9.5a1.6,1.6,0,0,0,.9,1.5L147.6,98c.5.2.9,0,.9-.6V87.9A2.2,2.2,0,0,0,147.6,86.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M135.2,75.9l-2.7-1.6a.5.5,0,0,0-.7.1.6.6,0,0,0-.1.4,1.6,1.6,0,0,0,.8,1.4l2.7,1.6c.5.2.8.1.8-.5A1.6,1.6,0,0,0,135.2,75.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M135,68.8h-.6c-.3.3-.3.8.1,1.4l2.2,3.3.5.5h.6c.3-.3.2-.9-.1-1.4l-2.1-3.2A1.7,1.7,0,0,0,135,68.8Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M142,69.6c-.4-.2-.8-.1-.8.5v3.1a1.6,1.6,0,0,0,.8,1.3c.5.3.8.1.8-.4V71A1.6,1.6,0,0,0,142,69.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M149.1,77a.7.7,0,0,0-.6-.1l-2.1.8c-.4.1-.4.7-.1,1.2a1.3,1.3,0,0,0,.6.7.7.7,0,0,0,.6.1l2.1-.8c.4-.1.4-.7.1-1.2S149.2,77,149.1,77Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M151.5,85.3l-2.8-1.5a.5.5,0,0,0-.7.1.4.4,0,0,0-.1.3,1.6,1.6,0,0,0,.8,1.3l2.8,1.6a.5.5,0,0,0,.7-.1.4.4,0,0,0,.1-.3A1.6,1.6,0,0,0,151.5,85.3Z"
        transform="translate(0 -0.1)"
      />
    </g>
    <g id="ssl">
      <path
        class="cls-2"
        d="M95.4,63.4l8.2-5.3v-.3L93.1,45.4h-.2l-1.6,7.5-.4,5.4v.2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M95.2,64.4a1.8,1.8,0,0,1-.9-.4l-4.5-5.3v-.4l.4-5.4,1.9-8.4.6-.2c.4,0,.8,0,1,.4l10.7,12.9v.5c0,.2-.2.6-.4.6L95.8,64C95.6,64.4,95.4,64.4,95.2,64.4Zm-3.5-6.3,3.7,4.3,6.9-4.6L93.5,47l-1.4,6.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M126.3,25.5,87.2,3a3.1,3.1,0,0,0-2.5-.4L77.1,7.1c-.2,0-.2.2,0,.4l9.3,9.6V33.3a8.9,8.9,0,0,0,4.1,6.9l5.7,3.3c.2.2.2.4.4.6a19.9,19.9,0,0,0,9,13.5c.2.2.4,0,.2-.4s-2.7-5.7-2.2-8.8a.7.7,0,0,1,.6-.2l12,7v.2l5.2,13.3.2.2,7.5-4.5a2.7,2.7,0,0,0,1.1-2.5V32.3A8.5,8.5,0,0,0,126.3,25.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M121.8,69.7l-.6-.2c-.2-.2-.7-.4-.7-.6l-4.9-13.1-11.2-6.5c-.2,2.6,1.4,6.1,2.2,7.3s.2,1.2-.2,1.5a1,1,0,0,1-1.4,0,22.1,22.1,0,0,1-9.4-14l-.2-.2-5.8-3.2a10.4,10.4,0,0,1-4.5-7.8V17.3l-9-9.4c-.2-.2-.4-.6-.2-.8s.2-.6.6-.8l7.6-4.5a3.6,3.6,0,0,1,3.5.4l39.1,22.5a10.2,10.2,0,0,1,4.5,7.8V61.9a3.8,3.8,0,0,1-1.4,3.3ZM104.2,47.2l12.7,7.4.2.4,4.7,12.7,6.7-4.1c.4-.2.6-.8.6-1.7V32.3a8,8,0,0,0-3.4-6.2L86.6,3.6a3.1,3.1,0,0,0-1.9-.4L78,7.3l9,9.4V33.1a7.7,7.7,0,0,0,3.5,6.1l6.1,3.7.6,1a20.7,20.7,0,0,0,6.6,11.5c-.9-2.1-1.7-4.7-1.3-7V48Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M118.5,30.2,79.4,7.5c-2-1.2-3.9-.2-3.9,2.2V39.2A9.4,9.4,0,0,0,79.4,46l5.9,3.5c.2,0,.2.2.2.4a21.5,21.5,0,0,0,9,13.7c.3.2.5,0,.3-.4s-2.9-6-2.1-9c0-.2.2-.2.4-.2l25.2,14.5c2,1.2,3.9.2,3.9-2.3V37A7.5,7.5,0,0,0,118.5,30.2Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M120.3,70.1a4.3,4.3,0,0,1-2.2-.6L93.7,55.4c-.2,2.7,1.5,6.1,2.3,7.4s.2,1.2-.2,1.4a1.1,1.1,0,0,1-1.5,0,22.2,22.2,0,0,1-9.4-13.9L79,46.8a9.1,9.1,0,0,1-4.3-7.4V9.7a3.4,3.4,0,0,1,1.6-3.2,4,4,0,0,1,3.7.2l39.1,22.5a9.4,9.4,0,0,1,4.3,7.6V66.2a3.6,3.6,0,0,1-1.6,3.3A2,2,0,0,1,120.3,70.1Zm-27.2-17a.7.7,0,0,1,.6.2l25.2,14.6c.8.4,1.4.6,1.9.2s.6-.8.6-1.9V37a8.2,8.2,0,0,0-3.5-6L78.8,8.5c-.8-.4-1.4-.6-1.9-.2s-.6.8-.6,1.9V39.6a8.2,8.2,0,0,0,3.5,6L85.7,49a2.4,2.4,0,0,1,.9,1.1,21.2,21.2,0,0,0,6.5,11.4c-.8-2.2-1.6-4.9-1-7.3l.2-.4.6-.5A.2.2,0,0,1,93.1,53.1Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M90.2,4.7,83.4,8.9l1,1.6,6.8-4.2Z" transform="translate(0 -0.1)" />
      <g class="cls-5">
        <g>
          <path
            class="cls-4"
            d="M86.2,24.3a4.6,4.6,0,0,0-3.6-.9c-.9.3-1.4,1-1.4,2.4a6.3,6.3,0,0,0,1.2,3.7,38.1,38.1,0,0,0,3.7,4.3,6.5,6.5,0,0,1,1.7,2,2.1,2.1,0,0,1,.5,1.5c0,.5-.1.8-.5.9s-.7,0-1.4-.4a4.6,4.6,0,0,1-1.7-1.7,2.9,2.9,0,0,1-.7-2.2l-3.1-1.8A7.8,7.8,0,0,0,82.5,37a12.7,12.7,0,0,0,3.8,3.5,5.5,5.5,0,0,0,3.7,1q1.5-.3,1.5-2.4a8.9,8.9,0,0,0-1.2-3.9,22.3,22.3,0,0,0-3.5-4l-1.9-2.1a2,2,0,0,1-.6-1.5,1.1,1.1,0,0,1,.6-.9,1.5,1.5,0,0,1,1.3.3,3.4,3.4,0,0,1,1.5,1.4,3.3,3.3,0,0,1,.6,1.9l3,1.8A7.5,7.5,0,0,0,90,27.8,10.6,10.6,0,0,0,86.2,24.3Z"
            transform="translate(0 -0.1)"
          />
          <path
            class="cls-4"
            d="M98,31.2a4.6,4.6,0,0,0-3.6-.9A2.2,2.2,0,0,0,93,32.7a6.3,6.3,0,0,0,1.2,3.7,29.3,29.3,0,0,0,3.7,4.2,11.2,11.2,0,0,1,1.8,2,2.9,2.9,0,0,1,.4,1.6c0,.4-.1.7-.4.8a2.1,2.1,0,0,1-1.5-.4,4.6,4.6,0,0,1-2.3-4l-3-1.7a7.6,7.6,0,0,0,1.5,4.8,12.7,12.7,0,0,0,3.8,3.5c1.6.9,2.8,1.3,3.8,1s1.4-1,1.4-2.4a6.4,6.4,0,0,0-1.2-3.8,23,23,0,0,0-3.5-4.1l-1.9-2.1a2.4,2.4,0,0,1-.5-1.4c0-.5.1-.8.4-.9a1.5,1.5,0,0,1,1.3.3,5.4,5.4,0,0,1,1.6,1.4,4.1,4.1,0,0,1,.5,1.9l3.1,1.8h0a8.3,8.3,0,0,0-1.3-4.3A8.6,8.6,0,0,0,98,31.2Z"
            transform="translate(0 -0.1)"
          />
          <path
            class="cls-4"
            d="M108.2,37.3,105,35.5V51.1l8.9,5.2V53.5l-5.8-3.4Z"
            transform="translate(0 -0.1)"
          />
        </g>
      </g>
    </g>
    <g id="lock">
      <path class="cls-2" d="M268.6,175.1l-4.4,2.5.4.6,4.3-2.5Z" transform="translate(0 -0.1)" />
      <path
        class="cls-2"
        d="M245.4,171.8h0l4.1-2.5c.2-.2.5-.1.9.1l1.5,1.3c.1.1,7.5,6.3,15.7,4.7h.5a4.6,4.6,0,0,1,2.6,1.5l.5.7c7.9,10.6,15.4,13.2,15.7,13.3l1.4.5a1.5,1.5,0,0,1,1,1.5v1.8c-.3,23-6.7,31.9-12,35.3l-5,3.1-.4-1h-1.8a2.4,2.4,0,0,1-1.5-.9c-.7-.7-15.3-16.7-18.6-49l-2.2-4.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M271.7,232.4h-1.6a3.2,3.2,0,0,1-1.8-1c-.6-.7-15.4-16.8-18.7-49.2l-2.1-4.9-2.4-5.5c-.1-.1,0-.4.2-.5l4.1-2.5a1.1,1.1,0,0,1,1.2.2l1.5,1.3c.3.2,7.5,6.1,15.4,4.6h.6a5,5,0,0,1,2.8,1.6l.5.7c7.9,10.6,15.3,13.2,15.6,13.3l1.5.5a1.9,1.9,0,0,1,1.3,1.8v1.8c-.4,23.1-6.9,32.2-12.3,35.7l-5.3,3.2Zm-4.1-56.7c-8.2,1.5-15.6-4.5-15.9-4.8l-1.6-1.3h-.3l-4,2.4,2.3,5.3,2.2,4.8h0c3.2,32.3,17.9,48.3,18.5,48.9a2.2,2.2,0,0,0,1.3.8h2.1l.3.8,4.6-2.9c5.2-3.4,11.5-12.2,11.9-35.1v-1.8a1.2,1.2,0,0,0-.8-1.1l-1.5-.5c-.3-.1-8-2.7-15.8-13.5l-.6-.7a4.1,4.1,0,0,0-2.3-1.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M249.5,169.2c.2-.2.5-.1.9.1l1.5,1.3c.1.1,7.5,6.3,15.7,4.7h.5a4.6,4.6,0,0,1,2.6,1.5l.5.7c7.9,10.6,15.4,13.2,15.7,13.3l1.4.5a1.2,1.2,0,0,1,.7.7l-12.3,7-26-11c-.3-1.9-.5-3.9-.7-5.9l-2.2-4.8-2.4-5.5h.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M250.4,188.2h0c-.3-1.9-.5-3.9-.7-5.8l-2.2-4.9-2.4-5.5c-.1-.1,0-.4.2-.5l4.1-2.5a1.1,1.1,0,0,1,1.2.2l1.5,1.3c.3.2,7.5,6.1,15.4,4.6h.6a5,5,0,0,1,2.8,1.6l.5.7c7.9,10.6,15.3,13.2,15.6,13.3l1.5.5a1.6,1.6,0,0,1,.9.7l.2.3-12.8,7.3Zm37.9,3.4-1.6-.5c-.3-.1-7.9-2.7-15.8-13.5l-.5-.6a4.3,4.3,0,0,0-2.3-1.4h-.4c-8.3,1.6-15.7-4.5-16-4.7l-1.5-1.3c-.2-.2-.4-.2-.4-.1l-3.9,2.4,2.3,5.2,2.2,4.9h0a53.5,53.5,0,0,0,.7,5.6l25.7,10.8,11.8-6.7Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M264.3,233.8c-.7-.8-18.5-20.2-19.2-59.7v-1.8c0-.6.5-.8,1.1-.4l1.5,1.3c.1.1,7.5,6.3,15.7,4.7h.5a4.6,4.6,0,0,1,2.6,1.5l.5.7c7.9,10.6,15.3,13.2,15.7,13.3l1.5.5a1.5,1.5,0,0,1,1,1.5v1.8c-.5,38.8-18.4,37.6-19.1,37.5A3.1,3.1,0,0,1,264.3,233.8Zm15.9-36.9c-3.4-1.8-8.8-5.6-14.4-12.9-.5-.5-.9-.8-1.3-.7-5.8.7-11.1-1.8-14.4-3.7-.4-.3-.7-.1-.7.5,1.1,26.6,10.4,42.2,14.6,47.8.6,1,1.9,2.2,2.6,2,4.1-1,13.1-6.5,14.3-31.7a1.7,1.7,0,0,0-.7-1.3Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M265.9,235a3.2,3.2,0,0,1-1.8-1c-.8-.8-18.7-20.2-19.3-59.9v-1.8a1.1,1.1,0,0,1,.5-.9c.4-.2.7,0,1.1.2l1.5,1.4c.3.2,7.5,6,15.4,4.6h.6a3.7,3.7,0,0,1,2.7,1.6,1.3,1.3,0,0,1,.6.7c7.8,10.5,15.2,13.1,15.5,13.2l1.5.5a1.9,1.9,0,0,1,1.3,1.8v1.8c-.4,20.9-5.8,30.1-10.3,34.1a13.2,13.2,0,0,1-8.8,3.7Zm-2.5-56.8c-8.2,1.5-15.6-4.5-15.9-4.7l-1.6-1.3-.3-.2c-.1,0-.1.1-.1.2v1.9c.6,39.3,18.3,58.6,19.1,59.4a2.2,2.2,0,0,0,1.3.8,12.9,12.9,0,0,0,8.9-3.6c4.3-3.9,9.6-13,10-33.6v-1.8a1.3,1.3,0,0,0-.8-1.2l-1.5-.4c-.3-.1-7.9-2.7-15.8-13.5l-.5-.7a4.1,4.1,0,0,0-2.3-1.3Zm.3,50c-4-5.5-13.5-21.2-14.6-48.1a1.1,1.1,0,0,1,.3-.8c.2-.2.6-.1.9,0,3.4,2.1,8.6,4.3,14.2,3.7a2.6,2.6,0,0,1,1.6.9,48.3,48.3,0,0,0,14.2,12.8,2.1,2.1,0,0,1,1,1.7c-1.3,26.9-11.5,31.2-14.6,31.9h-.2c-1,0-2.2-1.4-2.8-2.1Zm16.9-30a1.7,1.7,0,0,0-.6-1c-3.5-1.9-8.9-5.8-14.5-12.9a1.4,1.4,0,0,0-1-.7c-5.8.7-11.1-1.6-14.6-3.7h-.2a.4.4,0,0,0-.1.3c1.2,26.6,10.6,42.2,14.6,47.6.8,1.1,1.9,2,2.3,1.9,3-.8,12.8-5,14.1-31.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M250.1,179.6c3.3,1.9,8.7,4.3,14.4,3.7.4-.1.8.2,1.3.7a49.3,49.3,0,0,0,14.4,12.9,1.9,1.9,0,0,1,.7,1.4c-1.2,25.1-10.2,30.7-14.3,31.6-.7.2-1.9-1-2.6-1.9-4.1-5.7-13.5-21.3-14.6-47.9C249.4,179.6,249.7,179.3,250.1,179.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M250.1,179.6l2,1.1c1.5,26,10.5,41.2,14.6,46.8a7.7,7.7,0,0,0,1.9,1.7,4.8,4.8,0,0,1-2,.7c-.6.2-1.8-1-2.6-1.9-4.1-5.7-13.5-21.3-14.6-47.9C249.4,179.6,249.7,179.3,250.1,179.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M263.7,228.2c-4-5.5-13.5-21.2-14.6-48.1a1.1,1.1,0,0,1,.3-.8c.2-.2.6-.1.9,0l2,1.1h.2v.2c1.4,26,10.6,41.2,14.5,46.5a4.9,4.9,0,0,0,1.8,1.7l.6.3-.6.3-2,.7h-.2C265.5,230.3,264.3,228.9,263.7,228.2Zm2.7-.6c-3.9-5.4-13.1-20.6-14.6-46.7l-1.9-1h-.1a.4.4,0,0,0-.1.3c1.2,26.6,10.6,42.2,14.6,47.6.7,1.1,1.8,2,2.2,1.9l1.4-.4a8,8,0,0,1-1.5-1.7Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-2" d="M288.9,191.6l-4.3,2.5.3.5,4.3-2.4Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M286.3,190.4l-4.3,2.5.3.5,4.3-2.4Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M272.1,178.7l-4.4,2.5.4.5,4.3-2.4Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M251.6,170.2l-4.5,2.7.3.6,4.6-2.8Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M285.3,201.8l3.4-2.1V199l-3.4,2Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M279.7,225.2l3.4-2,.5-1.2-3.3,2.1Z" transform="translate(0 -0.1)" />
      <path class="cls-2" d="M259.5,178.2l4.4-2.5-.3-.6-5.4,3.1Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M266,226.2l-2.1,1.3.3.6,2.2-1.4Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M252.2,183.1l-2.7,1.6.4.6,2.6-1.7Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M252.6,186.9l-2.7,1.6.3.6,2.7-1.7Z" transform="translate(0 -0.1)" />
      <path
        class="cls-2"
        d="M263.7,228.2c-4-5.5-13.5-21.2-14.6-48.1a1.1,1.1,0,0,1,.3-.8c.2-.2.6-.1.9,0,3.4,2.1,8.6,4.3,14.2,3.7a2.6,2.6,0,0,1,1.6.9,48.3,48.3,0,0,0,14.2,12.8,2.1,2.1,0,0,1,1,1.7c-1.3,26.9-11.5,31.2-14.6,31.9h-.2C265.5,230.3,264.3,228.9,263.7,228.2Zm.8-44.6c-5.7.7-11.1-1.6-14.6-3.7h-.1a.4.4,0,0,0-.1.3c1.2,26.6,10.6,42.2,14.6,47.6.7,1.1,1.8,2,2.2,1.9,3-.7,12.8-4.9,14.1-31.4a1.7,1.7,0,0,0-.6-1c-3.5-1.9-8.9-5.8-14.5-12.9A1.6,1.6,0,0,0,264.5,183.6Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-4"
        d="M273.3,203.6a1.8,1.8,0,0,0-.8-1.5l-9.5-5.5h-.4a5,5,0,0,0-3.5,2.1l3.1,5.6v.5a6.5,6.5,0,0,0,2.8,5.4l.6.3,2.8,5a7.8,7.8,0,0,0,4-2.1l.2-.2V213a3.1,3.1,0,0,0,.6-1.9Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M268.2,216l-2.8-5.2-.5-.3a6.8,6.8,0,0,1-3-5.6v-.4l-3.1-5.8v-.2a5.5,5.5,0,0,1,3.7-2.2c.1-.1.4-.1.7.1l9.4,5.5a2.2,2.2,0,0,1,1,1.8v7.5a3.9,3.9,0,0,1-.6,2.1l-.2.2-.3.2a9.3,9.3,0,0,1-4.1,2.3Zm-8.7-17.3,3,5.5v.6a6.3,6.3,0,0,0,2.6,5l.7.4,2.7,4.9a9.8,9.8,0,0,0,3.6-2l.2-.2.2-.2a2.9,2.9,0,0,0,.4-1.6v-7.5a1.7,1.7,0,0,0-.7-1.3l-9.3-5.4h-.3a4.4,4.4,0,0,0-3.1,1.8Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M272.5,213.4c.1,0,.2-.2.2-.2h.1a2.6,2.6,0,0,0,.5-1.9v-7.6a6.5,6.5,0,0,0-.4-1.3l-4,2.5s-1.4,3.4-2.9,6.2l2.5,4.5A7.9,7.9,0,0,0,272.5,213.4Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M261.7,212.1l5.5,3.1c1.5.9,2.8,0,2.8-2.1v-7.5a1.6,1.6,0,0,0-.9-1.5l-9.4-5.5c-.5-.2-.8,0-.8.6v7.5A6.9,6.9,0,0,0,261.7,212.1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M268.3,216l-1.3-.4-5.4-3.1a6.8,6.8,0,0,1-3-5.7v-7.5a1.1,1.1,0,0,1,.5-.9.7.7,0,0,1,.9,0l9.4,5.4a2.2,2.2,0,0,1,1,1.8v7.5a2.9,2.9,0,0,1-1.1,2.6A1.9,1.9,0,0,1,268.3,216Zm-8.8-17.2h0a.5.5,0,0,0-.2.4v7.5a6.4,6.4,0,0,0,2.6,5.1l5.5,3.1a1.4,1.4,0,0,0,1.4.1c.6-.3.8-1,.8-1.9v-7.6a1.4,1.4,0,0,0-.6-1.2l-9.5-5.5Z"
        transform="translate(0 -0.1)"
      />
      <path class="cls-4" d="M265.5,210.7v-3.9h-.7v2.8l-.6-.3-.3.6Z" transform="translate(0 -0.1)" />
      <path
        class="cls-4"
        d="M265,208a3.1,3.1,0,0,1-1.4-2.3,1.1,1.1,0,0,1,.6-1.1,1.1,1.1,0,0,1,1.1,0,2.9,2.9,0,0,1,1.4,2.4,1.6,1.6,0,0,1-.5,1.1H265Zm-.5-2.9c-.2.1-.2.3-.2.5a2.5,2.5,0,0,0,1,1.8c.3.1.5.2.6.1a.8.8,0,0,0,.2-.5,2.7,2.7,0,0,0-1.1-1.8h-.5Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M263.3,205.7a3,3,0,0,0,1.3,2.1.7.7,0,0,0,1,.1.8.8,0,0,0,.2-.8,2.7,2.7,0,0,0-1.2-2.2C263.9,204.5,263.3,204.9,263.3,205.7Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-2"
        d="M264.4,208a3.1,3.1,0,0,1-1.4-2.3,1.1,1.1,0,0,1,.6-1.1,1.3,1.3,0,0,1,1.2,0,3.2,3.2,0,0,1,1.3,2.4,1.6,1.6,0,0,1-.5,1.1h-.5A.6.6,0,0,1,264.4,208Zm-.5-2.9c-.2.1-.2.3-.2.5a2.7,2.7,0,0,0,1.1,1.8c.2.1.4.2.5.1a.8.8,0,0,0,.2-.5,2.7,2.7,0,0,0-1.1-1.8h-.5Z"
        transform="translate(0 -0.1)"
      />
      <path d="M264.9,210.7v-3l-.7-.4v2.3l-.5-.3-.4.6Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M273,205.7l-2.7,1.7.2.5,2.8-1.7Z" transform="translate(0 -0.1)" />
      <path class="cls-3" d="M273,211.3l-2.8,1.6.3.5,2.7-1.7Z" transform="translate(0 -0.1)" />
      <path
        class="cls-4"
        d="M269.4,202.7a.9.9,0,0,1-1-.8v-4.3a4.1,4.1,0,0,0-1.8-3.2l-1.7-1-.7-.2a.8.8,0,0,0-.2.7V198a1.1,1.1,0,0,1-.9,1,1.1,1.1,0,0,1-1-1v-4.1a2.4,2.4,0,0,1,3.8-2.2l1.7,1a6.4,6.4,0,0,1,2.8,4.9v4.1A1.1,1.1,0,0,1,269.4,202.7Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M263.3,195h-.4v-1.4a1.6,1.6,0,0,1,.8-1.3,1.4,1.4,0,0,1,1.5,0l1.8,1.1-.2.3-1.8-1.1a1.1,1.1,0,0,0-1.1,0,1.1,1.1,0,0,0-.6,1Z"
        transform="translate(0 -0.1)"
      />
      <path
        class="cls-3"
        d="M269.3,198a5.4,5.4,0,0,0-.6-2.5l.3-.2a5.5,5.5,0,0,1,.7,2.8Z"
        transform="translate(0 -0.1)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    encryptAnim() {
      gsap.set("#lock, #ssl, #letsencrypt path", {
        opacity: 0,
        scale: 0.5,
        transformOrigin: "50% 50%",
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-letsencrypt",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
          },
        })
        .add("enc")
        .fromTo(
          "#lock, #ssl, #letsencrypt path",
          {
            opacity: 0,
            scale: 0.5,
            rotation: 20,
            y: 10,
          },
          {
            y: 0,
            opacity: 1,
            scale: 1,
            rotation: 0,
            stagger: 0.1,
            ease: "back.out(1.7)",
          },
          "enc"
        )
        .from(
          "#top-handle",
          {
            rotation: 20,
            transformOrigin: "100% 100%",
            ease: "sine",
          },
          "enc"
        )
        .from(
          "#camera",
          {
            x: 30,
            y: -10,
            ease: "sine",
          },
          "enc"
        );
    },
  },
  mounted() {
    this.encryptAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
}

.cls-2 {
  fill: #0e1e25;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4 {
  fill: #fff;
}

.cls-5 {
  clip-path: url(#clip-path);
}
</style>
